<template>
<div style="background:#27282d;" :class="iosClass">
   
    <!-- 直播中--视频直播 -->
    <div id="container" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==2&&baseList.auction_live_type==2&&containerShow==true&&qhmsType==11"></div>
    <!-- 直播中--同声传译视频--直播流 -->
    <div id="container2" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==2&&baseList.auction_live_type==2&&containerShow2==true&&qhmsType==13&&tongshengType==1"></div>
    <!-- 直播中--同声传译视频--视频地址 -->
    <div id="container3" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==2&&baseList.auction_live_type==2&&containerShow2==true&&qhmsType==13&&tongshengType==2"></div>
    <!-- 直播结束--视频直播--视频回放 -->
    <div id="container4" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==3&&baseList.ispersistent==1"></div>
    <!-- 直播结束--同声传译--视频 -->
    <div id="container5" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==3&&jieType==2&&tongshengType==2"></div>
    <!-- 直播结束--同声传译--直播流 -->
    <div id="container6" :class="(verticallyFlag?'verticallyClass':'horizontallyClass')+' '+((baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live0':'')" :style="'background-size: 100% 100%;position:absolute;left:0px;z-index:5;width:100%;height:'+shipinHeight+'px;background-image:url('+baseList.livepic+');top:'+(liveData.direction==2||verticallyFlag?'0':'5.2')+'rem;'" v-show="baseList.auction_status==3&&jieType==2&&tongshengType==1"></div>

    <van-icon name="play-circle-o" @click="shipin" color="#18BD6F" size="3rem" v-if="!verticallyFlag&&loading==false&&anniu==true&&baseList.auction_live_type==2&&baseList.auction_status==2&&baseList.ispause==0&&qhmsType==11" style="position:absolute;top:9.2rem;left:50%;margin-left:-1.5rem;z-index:7;" />
    <van-icon name="play-circle-o" @click="shipin" color="#18BD6F" size="3rem" v-if="verticallyFlag&&loading==false&&anniu==true&&baseList.auction_live_type==2&&baseList.auction_status==2&&baseList.ispause==0&&qhmsType==11" style="position:absolute;top:5.2rem;left:50%;margin-left:-1.5rem;z-index:7;" />
    <div class="load_box" v-if="loading">
        <img class="load_icon" src="../../assets/videoImg/loading.gif" alt="" />
        <div class="load_nr">正在进入直播间</div>
    </div>
    <!-- <div class="jieshu_box" v-if="baseList.auction_status==3&&baseList.auction_live_type==2&&jieshuShow==true">
            <div class="jieshu_nr">直播已结束</div>
            <van-button round type="primary" size="small" class="jieshu_btn" @click="huifang" v-if="baseList.have_review==1">直播回放</van-button>
            <van-button round type="primary" size="small" class="jieshu_btn" @click="back" v-if="baseList.have_review==0">返回</van-button>
        </div> -->
    <div v-show="code==0" :style="'position:relative;width:100%;height:'+xianshiH+'px;min-height: 100vh;'">
        <panel ref="panel" :extinfo="extinfo" :wapTitle="''" :appLink="appLink" :spreadID="'0'" :showNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
        <!-- 最底层 -->
        <!-- 全屏开始 -->
        <!-- <span style="color:#fff;position:relative;z-index:999;">{{baseList.auction_live_type}}--{{containerShow}}--{{qhmsType}}</span> -->
        <div :style="containerShow?'z-index:4;':'z-index:6;'" :class="baseList.auction_status==2&&baseList.auction_live_type==2&&liveData.direction==2?'live live0':'live'" v-show="baseList.auction_status==2">
            <!-- 直播中 -->
            <!-- <div id="container" class="container" :style="'height:'+shipinHeight+'px;background-image:url('+baseList.livepic+')'" v-show="baseList.auction_live_type==2&&containerShow==true&&qhmsType==11"></div> -->
            <!-- 视频 -->
            <div class="container_none" :style="'height:'+shipinHeight+'px;line-height:11rem;'" v-show="baseList.auction_live_type==2&&containerShow==false&&qhmsType==11">
                <img class="load_icon" src="../../assets/videoImg/loading.gif" alt="" />
                <!-- 视频无 -->
                <div class="container_none_con">{{noneText}}</div>
                <van-image @error="containerZt=false" fit="cover" :src="baseList.pauseurl" style="width:100%;height:100%;" v-if="containerZt==true" />
            </div>
            <!-- <div id="container2" class="container2" :style="'height:'+shipinHeight+'px;;background-image:url('+baseList.livepic+')'" v-show="baseList.auction_live_type==2&&containerShow2==true&&qhmsType==13&&tongshengType==1"></div> -->
            <!-- 同声传译视频--直播流 -->
            <!-- <div id="container3" class="container3" :style="'height:'+shipinHeight+'px;;background-image:url('+baseList.livepic+')'" v-show="baseList.auction_live_type==2&&containerShow2==true&&qhmsType==13&&tongshengType==2"></div> -->
            <!-- 同声传译视频--视频地址 -->
            <div class="container_none" :style="'height:'+shipinHeight+'px;line-height:11rem;'" v-show="baseList.auction_live_type==2&&containerShow2==false&&qhmsType==13">
                <img class="load_icon" src="../../assets/videoImg/loading.gif" alt="" />
                <div class="container_none_con">{{noneText2}}</div>
                <van-image @error="containerZt2=false" fit="cover" :src="baseList.pauseurl" style="width:100%;height:100%;" v-if="containerZt2==true" />
            </div><!-- 同声传译视频无 -->
            <div class="live-toux" v-show="baseList.auction_live_type==1&&qhmsType==12" :style="'height:'+tuwenHeight+'px;top:'+tuTop+'px'">
                <!-- 图文 -->
                <van-image fit="contain" :src="baseList.livepics" style="width:100%;height:100%;background:rgba(0,0,0,0.6);" />
            </div>
        </div>
        <!-- 全屏结束 -->
        <!-- 居中开始 -->
        <div :class="(baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live live0':'live'" v-show="(baseList.auction_status==1||baseList.auction_status==3)&&jieshuShow==true">
            <!-- <div class="live2" :style="'background-image:url('+baseList.livepic+')'">
                </div> -->
            <div class="live2" v-if="(baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2&&baseList.auction_status==3">
                <van-image fit="cover" :src="baseList.livepic" style="width:100%;height:100%;" />
            </div><!-- 竖屏 -->
            <div :class="(baseList.auction_status==2||baseList.auction_status==3)&&baseList.auction_live_type==2&&liveData.direction==2?'live2_box live2_box2':'live2_box'">
                <!-- <div class="live2_box"> -->
                <!-- 视频未开始、已结束 -->
                <div class="live2_box_con" :style="'height:'+shipinHeight+'px;line-height:11rem;'" v-show="baseList.auction_live_type==2">
                    <van-image fit="cover" :src="baseList.livepic" style="width:100%;height:100%;" v-show="baseList.auction_status==1" />
                    <div v-show="baseList.auction_status==3&&jieType==1">
                        <!-- 已结束--视频直播 -->
                        <!-- 等待转码 -->
                        <div class="tisBox" :style="'background-image:url('+baseList.livepic+')'" v-show="baseList.ispersistent==0&&(liveData.direction==0||liveData.direction==1)"></div>
                        <div class="tisCon" v-show="baseList.ispersistent==0">{{baseList.persistentmes}}</div>
                        <!-- 转码成功 -->
                        <!-- <div id="container4" class="container4" :style="'height:'+shipinHeight+'px;;background-image:url('+baseList.livepic+')'" v-show="baseList.ispersistent==1"></div> -->
                        <div class="tisCon2" v-show="baseList.ispersistent==1&&jieshuShow==true">
                            <van-button round type="primary" size="small" style="margin:100px auto 0px;display:block;" @click="huifang">直播回放</van-button>
                        </div>
                    </div>
                    <!-- <div style="width:100%;height:100%;" v-show="baseList.auction_status==3&&jieType==2&&tongshengType==2">
                            <div id="container5" class="container4" :style="'height:'+shipinHeight+'px;;background-image:url('+baseList.livepic+')'"></div>
                        </div> -->
                    <!-- 已结束--同声传译--视频 -->
                    <!-- <div style="width:100%;height:100%;" v-show="baseList.auction_status==3&&jieType==2&&tongshengType==1">
                            <div id="container6" class="container4" :style="'height:'+shipinHeight+'px;;background-image:url('+baseList.livepic+')'"></div>
                        </div> -->
                    <!-- 已结束--同声传译--直播流 -->
                </div>
                <!-- 图文未开始、已结束 -->
                <div class="live2_box_con" v-if="baseList.auction_live_type==1" :style="'height:'+shipinHeight+'px;'">
                    <!-- 图文横屏 -->
                    <van-image fit="cover" :src="baseList.livepic" style="width:100%;height:100%;" v-if="liveData.direction==0||liveData.direction==1" />
                </div>
                <!-- 横条 -->
                <div class="live2_box_zt" v-if="baseList.auction_status==1">
                    <div class="live2_box_ztL" v-if="baseList.live_type==1||baseList.live_type==3">
                        <p style="margin-top:0px;line-height:2.4rem;">{{baseList.livetimeTwo}}</p>
                    </div>
                    <div class="live2_box_ztL" v-if="baseList.live_type==2">
                        <span class="s1">待拍卖</span><span>拍品{{baseList.online_auction_count}}件</span>
                        <p>{{baseList.livetimeTwo}}</p>
                    </div>
                    <div class="live2_box_ztR" v-if="baseList.is_remind==0" @click="tixing()">
                        <span><img src="../../assets/videoImg/alarm-clock.png" alt="" />提醒我</span>
                    </div>
                    <div class="live2_box_ztR" v-if="baseList.is_remind==1">
                        <span>已设置提醒</span>
                    </div>
                </div>
                <div class="live2_box_zt" v-if="baseList.auction_status==3&&baseList.live_type==2&&xianshiHt==true">
                    <div class="live2_box_ztL">
                        <span class="s3">已结束</span><span>成交率：{{baseList.auction_turnover_ratio}}</span>
                        <p>本场总落槌价：{{baseList.auction_hammer_price}}</p>
                    </div>
                    <div class="live2_box_ztR" style="text-align:left;line-height:1.2rem;">
                        结束时间<br />{{baseList.end_live_time}}
                    </div>
                </div>
            </div>
        </div>
        <!-- 居中结束 -->
        <!-- 第二层级 -->
        <!-- <div class="secondFloor-live"> -->
        <!-- 顶部标题和观看人次 -->
        <div class="live-tit">
            <div class="live-zuhe" @click="synopsisOver">
                <div class="live-title">{{baseList.livename}}</div>
                <div class="live-photo">
                    <img src="../../assets/videoImg/iconnor.png" alt="" />
                </div>
            </div>
            <div class="live-renci">{{baseList.viewcount}}人次观看</div>
        </div>
        <!-- 头像 -->
        <div class="live-headPhoto" v-show="!verticallyFlag">
            <div class="headPhoto-1" @click="companyFun(company_data)" v-if="company_data.organ_id>0">
                <!-- <img class="headP-img" src="../../assets/videoImg/tx.jpg" alt="" /> -->
                <img class="headP-img" :src="company_data.headpic" alt="" />
                <!-- <img class="headP-bq" src="../../assets/videoImg/bq.png" alt="" /> -->
                <div class="headP-world van-ellipsis">{{company_data.name}}</div>
            </div>
            <div class="headPhoto-1" v-else>
            </div>
            <div class="headPhoto-2">
                <!-- 更多下拉菜单 -->
                <div v-if="show" style="border-radius: 0.25rem 0.25rem 0rem 0rem;overflow:hidden;">
                    <template v-for="(item, index) in function_menu">
                        <div :key="index" v-if="item.menu_type=='1'">
                            <div :class="qhmsShow==true?'menu-drop menu-drop-0 menu-drop-02':'menu-drop menu-drop-0'" @click="qhmsShow = !qhmsShow">
                                <div class="menu-dropWorld">{{ item.name }}</div>
                                <div class="menu-dropImg">
                                    <img src="../../assets/videoImg/right.png" alt="" />
                                </div>
                            </div>
                            <div class="qhmsBox" :style="qhmsShow==true?'height:'+(1.4*item.sub_list.length)+'rem;':'0rem;'">
                                <template v-for="(items, indexs) in item.sub_list">
                                    <div :class="items.is_default==1?'menu-drop menu-drop-02':'menu-drop'" @click="zbms(item.sub_list,items)" :key="indexs">
                                        <div class="menu-dropWorld">{{ items.name }}</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="menu-drop" @click="callPhone(item.parameter)" :key="index" v-else-if="item.menu_type=='5'">
                            <div class="menu-dropWorld"> {{ item.name }}</div>
                            <div class="menu-dropImg">
                                <img src="../../assets/videoImg/right.png" alt="" />
                            </div>
                        </div>
                        <div class="menu-drop" @click="gotoApp()" :key="index" v-else-if="item.menu_type=='4'">
                            <div class="menu-dropWorld"> {{ item.name }}</div>
                            <div class="menu-dropImg">
                                <img src="../../assets/videoImg/right.png" alt="" />
                            </div>
                        </div>
                        <div class="menu-drop" @click="select(item)" :key="index" v-else>
                            <div class="menu-dropWorld"> {{ item.name }}</div>
                            <div class="menu-dropImg">
                                <img src="../../assets/videoImg/right.png" alt="" />
                            </div>
                        </div>
                    </template>
                    <!-- 三角形 -->
                    <div class="menu-up" @click="pack">
                        <van-icon name="arrow-up" color="#FFFFFF" size="15" />
                    </div>
                </div>
                <div v-else>
                    <div class="menu-drop" style="border-radius:0.8rem;padding:0rem 0.3rem;">
                        <div class="menu-dropWorld" @click="select2">{{ value1 }}</div>
                        <div class="menu-dropImg" @click="select2">
                            <img src="../../assets/videoImg/right.png" alt="" />
                        </div>
                    </div>
                    <!-- <div class="menu-up" @click="pack">
                        <van-icon name="arrow-down" color="#FFFFFF" size="15" />
                        </div> -->
                </div>
            </div>
        </div>

        <!-- 底部图标 -->
        <div class="live-botmIcon" v-show="!verticallyFlag">
            <van-badge :content="baseList.online_auction_count?baseList.online_auction_count:goodsList.length" class="tulu_bq" v-if="baseList.live_type==1&&baseList.online_auction_count>0||baseList.live_type==1&&goodsList.length>0" />
            <img @click="shopOver" src="../../assets/videoImg/gwc.png" class="tulu_tb" alt="" v-if="baseList.live_type==1&&baseList.online_auction_count>0||baseList.live_type==1&&goodsList.length>0" />
            <van-badge :content="baseList.online_auction_count" class="tulu_bq" v-if="(baseList.live_type==2 || baseList.live_type==3)&&baseList.online_auction_count>0" />
            <img @click="moreOver" src="../../assets/videoImg/shopbag.png" class="tulu_tb" alt="" v-if="(baseList.live_type==2 || baseList.live_type==3)&&baseList.online_auction_count>0" />
                <template v-if="!isHarmony">
                    
                
                    <span :style="baseList.online_auction_count==0?'width: 9.5rem;':''" class="pinglun" @click="gotoApp()">说点什么...</span>
                    <img src="../../assets/videoImg/love.png" alt="" class="di_img" @click="gotoApp()" />
                    <!-- <img @click="barrageOver(!barrageShow)" src="../../assets/videoImg/tan1.png" alt="" class="di_img"/> -->
                    <template v-if="ifShowComment">
                        <img @click="barrageOver(!barrageShow)" src="../../assets/videoImg/tan1.png" alt="" class="di_img" v-if="barrageShow" />
                        <img @click="barrageOver(!barrageShow)" src="../../assets/videoImg/tan2.png" alt="" class="di_img" v-else />
                    </template>
                    <!-- <img src="../../assets/videoImg/分享.png" alt="" @click="showShare = true" />
                        <img src="../../assets/videoImg/关闭.png" alt="" @click="guanbi"/> -->
                    <div class="jin" @click="gotoApp()">近距离围观</div>
            </template>
        </div>
    </div>

    <downloadApp ref="downloadPop"></downloadApp><!-- 下载APP -->
    <watermark v-if="watermarkShow"></watermark><!-- 水印 -->
    <codeHtml ref="codeHtml" :codeHtmlShow="codeHtmlShow"></codeHtml><!-- 错误页面 -->
    <nonmember ref="nonmember" :nonmemberShow="nonmemberShow" :isLogin="liveData.isLogin"></nonmember><!-- 未开通会员 -->
    <synopsis ref="synopsis" :synopsisShow="synopsisShow" :liveData="liveData"></synopsis><!-- 简介 -->
    <focus ref="focus" :focusShow="focusShow" :liveData="liveData" :tuluTk="tuluTk" :baseList="baseList" :chujiadis="chujiadis" :yhxx="yhxx"></focus><!-- 图录 -->
    <shop v-if="baseList.live_type&&baseList.live_type!=1||goodsList.length>0" ref="shop" :shopShow="shopShow" :liveData="liveData" :goodsList="goodsList"></shop><!-- 商品列表页面 -->
    <template v-if="ifShowComment">
        <barrage v-show="!verticallyFlag" ref="barrage" :zxpInfo="zxpInfo" :zxpFlag="zxpFlag" :barrageShow="barrageShow" :chujiaData="chujiaData" :pinglunData="pinglunData" :jinruData="jinruData" :jinruClass="jinruClass" :chujiaClass="chujiaClass" :comment="comment" :plShow="plShow" :baseList="baseList" :plHeight="plHeight" :jinerBottom="jinerBottom" :jinBottom="jinBottom"></barrage><!-- 弹幕 -->
    </template>
    <div class="zxpinfoBox" v-if="zxpInfo.link != ''&&zxpFlag">
            <img @click="jumpZxp()" class="zxp-img" :src="zxpInfo.pic" alt="" />
            <div @click="jumpZxp()" class="zxp-text">
                {{ zxpInfo.title }}
            </div>
            <van-icon @click="zxpFlag=false" class="zxpCrossIcon" name="cross" />

        </div>

    <agreement ref="agreement" :agreementShow="agreementShow" :xieyiData="xieyiData"></agreement><!-- 协议 -->
    <offer ref="offer" :offerShow="offerShow" :offerType="offerType" :liveData="liveData" :yhxx="yhxx"></offer><!-- 出价 -->
    <announcement ref="announcement" :liveData="liveData" :announcementShow="announcementShow" :statisticalData="statisticalData" :newRecordData="newRecordData" :premiumData="premiumData" :zongshu="zongshu" :isVipMember="isVipMember"></announcement><!-- 新纪录榜&溢价榜 -->
    <moreList ref="moreList" :isMem="isMem" :moreListShow="moreListShow" :liveData="liveData" :tulu="tulu" :tuluList="tuluList" :tuluListOld="tuluListOld" :chujiadis="chujiadis" :yhxx="yhxx" :isVipMember="isVipMember" :havePrice="havePrice"></moreList><!-- 更多列表 -->
    <!-- </div> -->
    <div class="jiaBox" v-if="luoShow">
        <div class="jiaBox_name" v-if="luoType==1">落槌价</div>
        <div class="jiaBox_name" v-if="luoType==4" style="line-height:2.8rem;">即将落槌~</div>
        <div class="jiaBox_money" v-if="luoType==1"><span>RMB</span><b>{{luojia}}</b></div>
    </div>
</div>
</template>

<script>
import {
    getWXConfig
} from '@/assets/js/weixinShare'; //分享
import {
    mapActions,
    mapGetters
} from 'vuex';
import {
    initScoket,
    oncloseq
} from "@/assets/js/scoket" //长链
import {
    liveAuctionList,
    liveDetail,
    bidAgreement,
    changLian,
    liveAuctionStatistics,
    creat2,
    liveRemind,
    liveReloadList,
    auctionBids,
    livecommentlist,
    liveStatus,
    memberinfo
} from '@/api/live';
//直播间拍品列表、直播内容详情、参拍协议、长链、直播间拍品统计、竞拍拍品--出价记录
import downloadApp from "./components/downloadApp"; //下载APP 
import watermark from "./components/watermark"; //水印 
import codeHtml from "./components/codeHtml"; //错误页面
import nonmember from "./components/nonmember"; //未开通会员
import synopsis from "./components/synopsis"; //简介
import panel from "./components/panel"; //头部
import focus from "./components/focus"; //图录
import shop from "./components/shop"; //商品列表页面
import barrage from "./components/barrage"; //弹幕
import agreement from "./components/agreement"; //协议
import announcement from "./components/announcement"; //新纪录榜&溢价榜
import moreList from "./components/moreList"; //更多列表
import offer from "./components/offer"; //出价
import {
    scMdFunc
} from "@/assets/js/scData";
export default {
    name: "index",
    data() {
        return {
            zxpFlag:true,
            iosClass: '',
            goodsList: [],
            appLink: '/2/34/',
            loading: true,
            verticallyFlag: false,
            scoket: {}, //长链
            //WebSocket:{},
            code: 0, //错误页面
            isMem: 0,
            codeHtmlShow: false, //错误页面是否显示
            liveid: '', //直播内容详情id
            nonmemberShow: false, //未开通会员是否显示
            synopsisShow: false, //简介是否显示
            focusShow: false, //图录是否显示
            shopShow: false, //商品列表页面是否显示
            barrageShow: true, //弹幕是否显示
            agreementShow: false, //协议是否显示
            rulesShow: false, //规则是否显示
            offerShow: false, //出价是否显示
            watermarkShow: false, //水印是否显示
            offerType: '1', //出价类型
            announcementShow: false, //新纪录榜&溢价榜是否显示
            moreListShow: false, //更多列表是否显示
            value: "", //搜索框的绑定数据
            show: true, // 下拉框组件是否显示
            value1: "更多", //下拉数据
            liveData: '', //数据
            artData: '', //艺术号信息
            artId: '', //艺术号id
            attribute: '', //属性
            baseList: '', //基础
            chatRoomId: '', //聊天室id
            extinfo:'',
            comment: '', //评论列表
            company_data: '', //拍卖机构信息
            direction: '', //展示形式
            function_menu: '', //更多菜单
            goods: '', //拍品列表
            isChatRoom: '', //
            isLogin: '', //是否登录
            iscollected: '', //选择
            seed: '', //
            shareinfo: '', //分享信息
            zxpInfo: {
                link: "",
            }, //在线拍
            viewStatus: '', //状态
            xieyiData: '', //协议
            tulu: '', //左下角--图录数据
            tuluList: [], //左下角--图录列表数据
            tuluListOld: [], //左下角--图录列表数据--已结拍
            tuluTk: [], //左下角--图录弹框数据
            tuluTkShow: false,
            tuluListMore: 0, //数据是否加载更多
            showShare: false, //分享是否显示
            luoShow: false, //即将落槌
            luojia: '', //即将落槌价
            luoType: '',
            shuliang: 0, //拍品列表每页的条目数
            chujiaData: [], //弹幕--出价
            pinglunData: [], //弹幕--评论
            jinruData: {}, //弹幕--进入直播间
            jinruClass: 'barrage-list barrage-list_0',
            chujiaClass: 'barrage-list barrage-list_1 barrage-list_1_1',
            statisticalData: [], //拍品--统计
            newRecordData: [], //拍品--新纪录榜
            premiumData: [], //拍品--溢价榜
            zongshu: 0, //拍品-统计总数
            yhxx: '',
            jieshuShow: true, //结束弹框是否显示
            anniu: false, //按钮是否显示
            chujiadis: false, //出价按钮是否禁用
            congpaiData: {}, //重拍数据
            tongshengType: 1, //同声传译类型--1：直播流；2：视频地址
            tongshengUrl: '', //同声传译直播流
            lid: '',
            plShow: true,
            containerShow: true, //视频是否播放
            containerShow2: true, //同声传译视频是否播放
            noneText: '', //视频错误信息
            noneText2: '', //同声传译视频错误信息
            containerZt: false, //视频是否暂停
            containerZt2: false, //同声传译视频是否暂停
            containerZtShu: 0, //视频是否暂停--次数
            containerZtShu2: 0, //同声传译视频是否暂停--次数
            containerZtShu3: 0, //同声传译视频是否暂停--次数
            shipinHeight: 0, //视频的高度
            tuwenHeight: 0, //图文的高度
            plHeight: 0, //评论的高度
            jinerBottom: 0, //金额的底边距
            jinBottom: 0, //进入的底边距
            qhmsShow: true, //切换模式
            qhmsType: 11, //切换类型--默认视频直播
            jieType: 1, //已结拍视频类型--1：视频直播；2：同声传译
            tuTop: 0, //图文的top
            playerBox: '', //直播流的内容
            playerBox2: '', //直播流的内容
            playerBox3: '', //视频的内容
            playerBox4: '', //视频的内容
            playerBox5: '', //视频的内容
            playerBox6: '', //直播流的内容
            playerShow: true, //是否第一次点击
            playerShow2: true, //是否第一次点击
            playerShow3: true, //是否第一次点击
            playerShow4: true, //是否第一次点击
            playerShow5: true, //是否第一次点击
            playerShow6: true, //是否第一次点击
            xianshiHt: true, //横条显示
            xianshiH: 0, //显示的高度
            isVipMember: 0,
            havePrice: 0,
            ifShowComment: false, //是否显示弹幕
            isHarmony: false,
        };
    },
    components: {
        downloadApp, //下载APP
        watermark, //水印
        codeHtml, //错误页面
        nonmember, //未开通会员
        synopsis, //简介
        focus, //图录
        shop, //商品列表页面
        barrage, //弹幕
        agreement, //协议
        announcement, //新纪录榜&溢价榜
        moreList, //更多列表
        offer, //出价
        panel
    },
    created() {
        if (this.$route.query.from == '2') {
            this.watermarkShow = true;
        }
        
       

    },
    beforeRouteEnter(to, from, next) {
        next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
            //alert(from.name)
            // console.log(from.name)
            // console.log(to.name)
            if (from.name == null) {

                vm.anniu = false;
            } else {
                let events = navigator.userAgent
                if (events.indexOf('iPhone') > -1 || events.indexOf('iPad') > -1) {
                    vm.anniu = false;
                } else {
                    vm.anniu = false;
                }

            }
        })
    },

    mounted() {
        let that = this;
        const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.isHarmony=(/(HarmonyOSTulu)/g).test(navigator.userAgent)
        this.liveid = Number(this.$route.query.id);
        this.extinfo=JSON.stringify({url: "pastLive",param: this.$route.query.id+"@"+this.$route.query.special_id})
        if (this.isWeiXin() && isiOS) {
            this.playerBox = new TcPlayer('container', {
                "live": true, //是否为直播类型
                "m3u8": '111111',
                "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                // "pausePosterEnabled": true, //暂停时显示封面
                // "poster": this.baseList.livepic, //封面图
                "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                "controls": "system", //控件隐藏
                "systemFullscreen": true,
                "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                "flash": false,
                "listener": function (msg) {
                    console.log(msg.type)
                    if (msg.type == "load") {
                        that.playerBox.play();
                    }
                    if (msg.type == "error") {

                        that.containerShow = false
                        that.containerZt = true
                        that.noneText = '主播走开了，请稍等片刻'
                        that.getLiveStatus(1, that.containerZtShu)
                    }
                    if (msg.type == "playing") {
                        let tagslist = document.getElementsByClassName("vcp-error-tips");
                        if (isiOS) {
                            that.iosClass = "shield"
                        }
                        for (let i = 0; i < tagslist.length; i++) {
                            tagslist[i].style = "display:none";
                        }
                        that.containerShow = true
                        that.containerZt = false
                        that.containerZtShu = 0
                        that.noneText = ''
                    }
                    //进行事件处理
                }

            });
        }
        // const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // if (isiOS&&this.$route.query.id) {
        //     window.location.href = "https://artexpress.artron.net/liveShare/" + this.$route.query.id
        // }
        //console.log(this.liveid);
        this.getMemTypeFun();
        this.getCreat2();
        if (!this.getIsLoadIng) {
            console.log("启用前端调用");
            let params = {
                liveid: Number(this.$route.query.id), //直播id
                special_id: Number(this.$route.query.special_id), //专场id
            }
            this.fetchToLive([params, () => {
                this.filteData();
            }]);
        } else {
            console.log("服务端调用");
            this.filteData();
        }

        if (window.orientation === 90 || window.orientation === -90) {
            let zbType = sessionStorage.getItem('zbType')
            let zbYun = sessionStorage.getItem('zbYun')
            that.verticallyFlag = true;

            if (zbYun == 1) {
                if (zbType == 1) {

                    if (typeof (that.playerBox.fullscreen) == "function") {
                        that.playerBox.fullscreen(true)
                    }
                } else if (zbType == 2) {

                    if (typeof (that.playerBox2.fullscreen) == "function") {
                        that.playerBox2.fullscreen(true)
                    }
                } else if (zbType == 3) {

                    if (typeof (that.playerBox3.fullscreen) == "function") {
                        that.playerBox3.fullscreen(true)
                    }
                } else if (zbType == 4) {

                    if (typeof (that.playerBox4.fullscreen) == "function") {
                        that.playerBox4.fullscreen(true)
                    }
                } else if (zbType == 5) {

                    if (typeof (that.playerBox5.fullscreen) == "function") {
                        that.playerBox5.fullscreen(true)
                    }
                } else if (zbType == 6) {

                    if (typeof (that.playerBox6.fullscreen) == "function") {
                        that.playerBox6.fullscreen(true)
                    }
                }
            }
            setTimeout(() => {
                that.shipinHeight = document.body.offsetHeight;
                that.xianshiH = document.body.offsetHeight
                that.$forceUpdate();
            }, 200);

        }
        window.addEventListener("orientationchange", function () {
            let zbType = sessionStorage.getItem('zbType')
            let zbYun = sessionStorage.getItem('zbYun')
            if (window.orientation === 90 || window.orientation === -90) {

                that.verticallyFlag = true;
                if (zbYun == 1) {
                    if (zbType == 1) {

                        if (typeof (that.playerBox.fullscreen) == "function") {
                            that.playerBox.fullscreen(true)
                        }
                    } else if (zbType == 2) {

                        if (typeof (that.playerBox2.fullscreen) == "function") {
                            that.playerBox2.fullscreen(true)
                        }
                    } else if (zbType == 3) {

                        if (typeof (that.playerBox3.fullscreen) == "function") {
                            that.playerBox3.fullscreen(true)
                        }
                    } else if (zbType == 4) {

                        if (typeof (that.playerBox4.fullscreen) == "function") {
                            that.playerBox4.fullscreen(true)
                        }
                    } else if (zbType == 5) {

                        if (typeof (that.playerBox5.fullscreen) == "function") {
                            that.playerBox5.fullscreen(true)
                        }
                    } else if (zbType == 6) {

                        if (typeof (that.playerBox6.fullscreen) == "function") {
                            that.playerBox6.fullscreen(true)
                        }
                    }
                }

                setTimeout(() => {
                    that.shipinHeight = document.body.offsetHeight
                    that.xianshiH = document.body.offsetHeight
                    that.$forceUpdate();
                }, 200);

            }
            if (window.orientation === 0) {
                that.verticallyFlag = false;
                if (zbYun == 1) {
                    if (zbType == 1) {

                        if (typeof (that.playerBox.fullscreen) == "function") {
                            that.playerBox.fullscreen(false)
                        }
                    } else if (zbType == 2) {

                        if (typeof (that.playerBox2.fullscreen) == "function") {
                            that.playerBox2.fullscreen(false)
                        }
                    } else if (zbType == 3) {

                        if (typeof (that.playerBox3.fullscreen) == "function") {
                            that.playerBox3.fullscreen(false)
                        }
                    } else if (zbType == 4) {

                        if (typeof (that.playerBox4.fullscreen) == "function") {
                            that.playerBox4.fullscreen(false)
                        }
                    } else if (zbType == 5) {

                        if (typeof (that.playerBox5.fullscreen) == "function") {
                            that.playerBox5.fullscreen(false)
                        }
                    } else if (zbType == 6) {

                        if (typeof (that.playerBox6.fullscreen) == "function") {
                            that.playerBox6.fullscreen(false)
                        }
                    }
                }
                setTimeout(() => {
                    that.shipinHeight = document.body.offsetWidth * 9 / 16
                    that.xianshiH = document.body.offsetHeight
                    that.$forceUpdate();
                }, 200);

            }
        }, false);
        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === 'visible') {
                let zbType = sessionStorage.getItem('zbType')
                let zbYun = sessionStorage.getItem('zbYun')
                if (that.baseList.auction_live_type == 2) {

                    if (zbYun == 1) {
                        if (zbType == 1 && that.baseList.auction_status == 2) {

                            that.playerPlay() //播放
                        } else if (zbType == 2 && that.baseList.auction_status == 2) {

                            that.playerPlay2() //播放
                        } else if (zbType == 3 && that.baseList.auction_status == 2) {

                            that.playerPlay3() //播放
                        } else if (zbType == 4 && that.baseList.auction_status == 3) {

                            that.playerPlay4() //播放
                        } else if (zbType == 5 && that.baseList.auction_status == 3) {

                            that.playerPlay5() //播放
                        } else if (zbType == 6 && that.baseList.auction_status == 3) {

                            that.playerPlay6() //播放
                        }
                    }
                }
            } else {
                let zbType = sessionStorage.getItem('zbType')
                let zbYun = sessionStorage.getItem('zbYun')
                if (that.baseList.auction_live_type == 2) {

                    if (zbYun == 1) {
                        if (zbType == 1 && that.baseList.auction_status == 2) {

                            that.playerStop() //停止
                        } else if (zbType == 2 && that.baseList.auction_status == 2) {

                            that.playerStop2() //停止
                        } else if (zbType == 3 && that.baseList.auction_status == 2) {

                            that.playerStop3() //停止
                        } else if (zbType == 4 && that.baseList.auction_status == 3) {

                            that.playerStop4() //停止
                        } else if (zbType == 5 && that.baseList.auction_status == 3) {

                            that.playerStop5() //停止
                        } else if (zbType == 6 && that.baseList.auction_status == 3) {

                            that.playerStop6() //停止
                        }
                    }
                }

            }
        });
        //  this.iosClass="shield"
        // const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // if (isiOS) {
        //     this.iosClass = "shield"
        // }
        scMdFunc('vipBenefitsEntryPage', {
            current_page: '直播详情页'
        })
       
    },
    destroyed: function () {
        oncloseq() //销毁长链
        var zbType = sessionStorage.getItem('zbType')
        var zbYun = sessionStorage.getItem('zbYun')
        if (this.baseList.auction_live_type == 2) {
            if (zbYun == 1) {
                if (zbType == 1 && this.baseList.auction_status == 2) {
                    this.playerStop() //停止
                } else if (zbType == 2 && this.baseList.auction_status == 2) {
                    this.playerStop2() //停止
                } else if (zbType == 3 && this.baseList.auction_status == 2) {
                    this.playerStop3() //停止
                } else if (zbType == 4 && this.baseList.auction_status == 3) {
                    this.playerStop4() //停止
                } else if (zbType == 5 && this.baseList.auction_status == 3) {
                    this.playerStop5() //停止
                } else if (zbType == 6 && this.baseList.auction_status == 3) {
                    this.playerStop6() //停止
                }
            }
        }
    },

    //服务端渲染
    asyncData({
        store,
        route
    }) {
        let params = {
            liveid: Number(route.query.id), //直播id
            special_id: Number(route.query.special_id), //专场id
        }
        return store.dispatch("live/fetchToLive", [params, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "live/getIsLoadIng",
            liveListGetData: "live/getData",
        }),
    },

    methods: {
        jumpZxp(){
            window.location.href=this.zxpInfo.link
        },
        getMemTypeFun() {
            memberinfo().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember;
                    this.isVipMember = res.data.isMember && res.data.memberStatus == 2;
                }
            })
        },
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },
        playerPlay() { //直播中--视频直播--视频流--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow == true) {
                if (this.isWeiXin() && isiOS) {
                    this.playerBox.load(sessionStorage.getItem('zbUrl'))
                } else {
                    this.playerBox = new TcPlayer('container', {
                        "live": true, //是否为直播类型
                        "m3u8": sessionStorage.getItem('zbUrl'),
                        "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        // "pausePosterEnabled": true, //暂停时显示封面
                        // "poster": this.baseList.livepic, //封面图
                        "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                        "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                        "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                        "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                        "systemFullscreen": true,
                        "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                        "flash": false,
                        "listener": function (msg) {
                            console.log(msg.type)
                            if (msg.type == "load") {
                                that.playerBox.play();
                            }
                            if (msg.type == "error") {

                                that.containerShow = false
                                that.containerZt = true
                                that.noneText = '主播走开了，请稍等片刻'
                                that.getLiveStatus(1, that.containerZtShu)
                            }
                            if (msg.type == "playing") {
                                let tagslist = document.getElementsByClassName("vcp-error-tips");
                                if (isiOS) {
                                    that.iosClass = "shield"
                                }
                                for (let i = 0; i < tagslist.length; i++) {
                                    tagslist[i].style = "display:none";
                                }
                                that.containerShow = true
                                that.containerZt = false
                                that.containerZtShu = 0
                                that.noneText = ''
                            }
                            //进行事件处理
                        }

                    });
                }
                this.playerShow = false
            }

        },
        playerStop() { //直播中--视频直播--视频流--暂停
            let that = this;
            if (typeof (this.playerBox.pause) == "function") {
                try {
                    console.log('pause1')
                    that.playerBox.pause() //停止直播--视频
                } catch (error) {
                    //console.log(error);
                }

            }
        },
        playerPlay2() { //直播中--同声传译--视频流--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow2 == true) {
                let liveObj = {
                    "live": true, //是否为直播类型

                    "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "pausePosterEnabled": true, //暂停时显示封面
                    "poster": this.baseList.livepic, //封面图
                    "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                    "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                    "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                    "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                    "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                    "flash": false,
                    "listener": function (msg) {

                        // console.log(msg.type)
                        if (msg.type == "error") {

                            that.containerShow2 = false
                            that.containerZt2 = true
                            that.noneText2 = '主播走开了，请稍等片刻'
                            that.getLiveStatus(1, that.containerZtShu2)
                        }
                        if (msg.type == "playing") {
                            let tagslist = document.getElementsByClassName("vcp-error-tips");
                            if (isiOS) {
                                that.iosClass = "shield"
                            }
                            for (let i = 0; i < tagslist.length; i++) {
                                tagslist[i].style = "display:none";
                            }
                            that.containerShow2 = true
                            that.containerZt2 = false
                            that.containerZtShu2 = 0
                            that.noneText2 = ''
                        }

                        //进行事件处理
                    }
                }
                if (sessionStorage.getItem('zbUrl').indexOf(".m3u8") != -1) {
                    liveObj['m3u8'] = sessionStorage.getItem('zbUrl');
                }
                if (sessionStorage.getItem('zbUrl').indexOf("webrtc://") != -1) {
                    liveObj['webrtc'] = sessionStorage.getItem('zbUrl');
                }
                if (sessionStorage.getItem('zbUrl').indexOf(".flv") != -1) {
                    liveObj['flv'] = sessionStorage.getItem('zbUrl');
                }
                if (sessionStorage.getItem('zbUrl').indexOf("rtmp://") != -1) {
                    liveObj['rtmp'] = sessionStorage.getItem('zbUrl');
                }

                this.playerBox2 = new TcPlayer('container2', liveObj);
                this.playerShow2 = false
            }
            this.playerBox2.play();
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        playerStop2() { //直播中--同声传译--视频流--暂停
            let that = this;
            if (typeof (this.playerBox2.pause) == "function") {
                try {
                    that.playerBox2.pause() //停止直播--视频
                } catch (error) {
                    //console.log(error);
                }

            }
        },
        playerPlay3() { //直播中--同声传译--视频--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow3 == true) {
                this.playerBox3 = new TcPlayer('container3', {
                    "live": false, //是否为直播类型
                    "mp4": sessionStorage.getItem('zbUrl'), //mp4播放--成功
                    "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "pausePosterEnabled": true, //暂停时显示封面
                    "poster": this.baseList.livepic, //封面图
                    "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                    "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                    "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                    "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                    "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                    "flash": false,
                    "listener": function (msg) {

                        // console.log(msg.type)
                        if (msg.type == "error") {

                            that.containerShow2 = false
                            that.containerZt2 = true
                            that.noneText2 = '主播走开了，请稍等片刻'
                            that.getLiveStatus(1, that.containerZtShu2)
                        }
                        if (msg.type == "playing") {
                            let tagslist = document.getElementsByClassName("vcp-error-tips");
                            if (isiOS) {
                                that.iosClass = "shield"
                            }
                            for (let i = 0; i < tagslist.length; i++) {
                                tagslist[i].style = "display:none";
                            }
                            that.containerShow2 = true
                            that.containerZt2 = false
                            that.containerZtShu2 = 0
                            that.noneText2 = ''
                        }

                        //进行事件处理
                    }
                });
                this.playerShow3 = false
            }
            this.playerBox3.play()
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        playerStop3() { //直播中--同声传译--视频--暂停
            let that = this;
            if (typeof (that.playerBox3.pause) == "function") {
                try {
                    that.playerBox3.pause() //停止直播--视频
                } catch (error) {
                    //console.log(error);
                }

            }
        },
        playerPlay4() { //直播结束--视频直播--视频--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow4 == true) {
                this.playerBox4 = new TcPlayer('container4', {
                    "live": false, //是否为直播类型
                    "mp4": sessionStorage.getItem('zbUrl'), //mp4播放--成功
                    "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "pausePosterEnabled": true, //暂停时显示封面
                    "poster": this.baseList.livepic, //封面图
                    "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                    "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                    "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                    "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                    "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                    "flash": false,
                    "listener": function (msg) {

                        // console.log(msg.type)
                        if (msg.type == "error") {

                            that.containerShow = false
                            that.containerZt = true
                            that.noneText = '主播走开了，请稍等片刻'
                            that.getLiveStatus(1, that.containerZtShu)
                        }
                        if (msg.type == "playing") {
                            let tagslist = document.getElementsByClassName("vcp-error-tips");
                            if (isiOS) {
                                that.iosClass = "shield"
                            }
                            for (let i = 0; i < tagslist.length; i++) {
                                tagslist[i].style = "display:none";
                            }
                            that.containerShow = true
                            that.containerZt = false
                            that.containerZtShu = 0
                            that.noneText = ''
                        }

                        //进行事件处理
                    }
                });
                this.playerShow4 = false
            }
            this.playerBox4.play()
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        playerStop4() { //直播结束--视频直播--视频--暂停
            let that = this;
            if (typeof (that.playerBox4.pause) == "function") {
                try {
                    that.playerBox4.pause() //停止直播--视频
                } catch (error) {
                    //console.log(error);
                }

            }
        },
        playerPlay5() { //直播结束--同声传译--视频--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow5 == true) {
                this.playerBox5 = new TcPlayer('container5', {
                    "live": false, //是否为直播类型
                    "mp4": sessionStorage.getItem('zbUrl'), //mp4播放--成功
                    "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "pausePosterEnabled": true, //暂停时显示封面
                    "poster": this.baseList.livepic, //封面图
                    "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                    "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                    "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                    "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                    "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                    "flash": false,
                    "listener": function (msg) {

                        // console.log(msg.type)
                        if (msg.type == "error") {

                            that.containerShow = false
                            that.containerZt = true
                            that.noneText = '主播走开了，请稍等片刻'
                            that.getLiveStatus(1, that.containerZtShu)
                        }
                        if (msg.type == "playing") {
                            let tagslist = document.getElementsByClassName("vcp-error-tips");
                            if (isiOS) {
                                that.iosClass = "shield"
                            }
                            for (let i = 0; i < tagslist.length; i++) {
                                tagslist[i].style = "display:none";
                            }
                            that.containerShow = true
                            that.containerZt = false
                            that.containerZtShu = 0
                            that.noneText = ''
                        }

                        //进行事件处理
                    }
                });
                this.playerShow5 = false
            }
            this.playerBox5.play()
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        playerStop5() { //直播结束--同声传译--视频--暂停
            let that = this;
            if (typeof (that.playerBox5.pause) == "function") {
                try {
                    that.playerBox5.pause() //停止直播--视频
                } catch (error) {
                    console.log(error);
                }

            }
        },
        playerPlay6() { //直播结束--同声传译--视频流--播放
            let that = this;
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (this.playerShow6 == true) {
                this.playerBox6 = new TcPlayer('container6', {
                    "live": true, //是否为直播类型
                    "m3u8": sessionStorage.getItem('zbUrl'),
                    "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "pausePosterEnabled": true, //暂停时显示封面
                    "poster": this.baseList.livepic, //封面图
                    "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
                    "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
                    "x5_type": "h5-page", //启用同层 H5 播放器(非 TBS 内核不支持)
                    "controls": isiOS ? 'system' : this.direction == 2 ? "none" : "default", //控件隐藏
                    "x5_player": true, //是否启用 TBS 的播放 flv 或 hls
                    "flash": false,
                    "listener": function (msg) {

                        // console.log(msg.type)
                        if (msg.type == "error") {

                            that.containerShow = false
                            that.containerZt = true
                            that.noneText = '主播走开了，请稍等片刻'
                            that.getLiveStatus(1, that.containerZtShu)
                        }
                        if (msg.type == "playing") {
                            let tagslist = document.getElementsByClassName("vcp-error-tips");
                            if (isiOS) {
                                that.iosClass = "shield"
                            }
                            for (let i = 0; i < tagslist.length; i++) {
                                tagslist[i].style = "display:none";
                            }
                            that.containerShow = true
                            that.containerZt = false
                            that.containerZtShu = 0
                            that.noneText = ''
                        }

                        //进行事件处理
                    }
                });
                this.playerShow6 = false
            }
            this.playerBox6.play()
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        playerStop6() { //直播结束--同声传译--视频流--暂停
            let that = this;
            if (typeof (that.playerBox6.pause) == "function") {
                try {
                    that.playerBox6.pause() //停止直播--视频
                } catch (error) {
                    console.log(error);
                }
            }
        },
        sjs() {
            //x上限，y下限     
            var x = 100;
            var y = 0;
            return parseInt(Math.random() * (x - y + 1) + y);
        },
        changlian() {

            let that = this;
            //长链推送信息
            this.scoket = initScoket({
                authData: { //参数会变动调整
                    mid: 1,
                    //key: this.$route.query.id+this.yhxx.defaultRoles.roleKey,
                    key: this.$route.query.id + '-' + Date.parse(new Date()) + '-' + this.sjs() + Math.floor(Math.random() * 90) + '-' + Math.floor(Math.random() * 90),
                    connectKey: Date.parse(new Date()),
                    roomId: this.liveData.chatRoomId,
                    identity: this.$route.query.id + "@tulu"
                },
                onmessage: data => {
                    // debugger
                    // console.log("长链推送信息~")
                    // console.log(data);
                    // console.log(JSON.parse(data.extra) );
                    // eslint-disable-next-line no-debugger

                    var _this = this;
                    let extra = '';
                    if (data.extra != '' && data.extra != undefined && data.extra != null) {
                        extra = JSON.parse(data.extra);
                    }
                    // console.log(extra)
                    let source = '';
                    if (data.source != '' && data.source != undefined && data.source != null) {
                        source = JSON.parse(data.source);
                    }

                    if (data.mt == '1' && data.chatType == 3) { //推送弹幕--评论
                        this.pinglunData.push( //弹幕--评价--添加数据
                            {
                                uid: source.user,
                                username: source.nickName,
                                content: data.content
                            }
                        )
                        if (this.pinglunData.length > 0) {
                            this.$refs.barrage && this.$refs.barrage.jiapl(); //评论动画
                        }
                    } else if (data.mt == '4' && data.chatType == 3) { //直播观看人次、进入直播间
                        this.baseList.viewcount = this.baseList.viewcount + this.baseList.seed //直播观看人次
                        //进入直播间
                        this.jinruData.nickName = source.nickName
                        this.jinruData.content = data.content
                        this.jinruClass = 'barrage-list barrage-list_0 barrage-list_01'
                        setTimeout(function () {
                            _this.jinruClass = 'barrage-list barrage-list_0 barrage-list_02'
                        }, 2 * 1000);
                        setTimeout(function () {
                            _this.jinruClass = 'barrage-list barrage-list_0 barrage-list_03'
                        }, 3 * 1000);
                        setTimeout(function () {
                            _this.jinruClass = 'barrage-list barrage-list_0'
                        }, 4 * 1000);
                    }
                    if (data.mt == '12' && data.chatType == 5) { //专场状态(直播状态)
                        location.reload()
                        /* var last_id=''+extra.art_id;
                        if(extra.special_status==1){//开拍(直播中)
                            this.baseList.auction_status=2
                            this.getLiveAuctionList(this.company_data,1,1,last_id);//直播间拍品列表--拍卖中
                            this.getLiveAuctionList(this.company_data,2,1,last_id);//直播间拍品列表--已结拍
                        }else if(extra.special_status==2){//结拍(直播结束)
                            this.baseList.auction_status=3
                            this.getLiveAuctionList(this.company_data,2,1,last_id);//直播间拍品列表--已结拍
                        } */
                    } else if (data.mt == '13' && data.chatType == 5) { //拍品状态（1 成交 ，2 流拍 ，3 撤拍，4：即将落槌 5 重拍）

                        var art_id = extra.art_id;
                        if (extra.auction_status == 1 || extra.auction_status == 2 || extra.auction_status == 3) { //1 成交、2 流拍、3 撤拍
                            if (this.tuluList.length > 0) {
                                if (this.tuluList.length <= 3 && this.tuluListMore == 1) { //加载新的数据
                                    this.getLiveAuctionList(this.company_data, 1, 0, this.tuluList[this.tuluList.length - 1].lot); //直播间拍品列表--拍卖中

                                }
                                this.tuluList.forEach((item, index) => {
                                    if (art_id == item.art_id) {
                                        // console.log(item)
                                        // console.log(this.tuluList[0])
                                        // console.log(art_id)
                                        // // eslint-disable-next-line no-debugger
                                        // debugger
                                        this.tuluList.splice(index, 1); //拍卖中--删除拍品
                                        if (this.tuluList.length > 0) {
                                            this.tuluList[0].status = 2;
                                            this.tuluList[0].bid_price = extra.next_price;
                                            this.tuluList[0].extra_info = [{
                                                    type: "current_price",
                                                    label: "当前价",
                                                    text: extra.price_show,
                                                    small_text: extra.currency_type
                                                },
                                                {
                                                    type: "next_price",
                                                    label: "下口价",
                                                    text: extra.next_price_show,
                                                    small_text: extra.currency_type
                                                }
                                            ]; //拍卖中--第一个拍品
                                        }
                                        //添加不同的状态
                                        if (extra.auction_status == 1 && extra.hammer_price_show) { //成交
                                            // item.extra_info = [{
                                            //     type: "price",
                                            //     label: "落槌价",
                                            //     text: extra.hammer_price_show,
                                            //     small_text: extra.currency_type
                                            // }]

                                            if (extra.auction_detail.length > 0) {
                                                item.extra_info = extra.auction_detail[0].extra_info
                                            }

                                            item.status = 3;
                                        }
                                        console.log(extra.auction_detail[0].extra_info)
                                        if (extra.auction_status == 2) { //流拍
                                            if (extra.auction_detail.length > 0) {
                                                item.extra_info = extra.auction_detail[0].extra_info
                                            }
                                            // item.extra_info = [{
                                            //     type: "not_price",
                                            //     label: "",
                                            //     text: "流拍",
                                            //     small_text: ""
                                            // }]
                                        }
                                        if (extra.auction_status == 3) { //撤拍
                                            if (extra.auction_detail.length > 0) {
                                                item.extra_info = extra.auction_detail[0].extra_info
                                            }
                                            // item.extra_info = [{
                                            //     type: "not_price",
                                            //     label: "",
                                            //     text: "撤拍",
                                            //     small_text: ""
                                            // }]
                                        }
                                        this.tuluListOld.unshift(item); //已结拍--增加拍品
                                    }
                                });
                                //拍品显示
                                if (this.tuluList.length > 0) {
                                    this.tuluTkShow = true;
                                    this.tuluTk = this.tuluList[0];
                                    this.tuluTk.deposit_amount = this.tulu.deposit_amount;
                                    //this.tuluTk.currency_type=extra.currency_type;
                                    this.baseList.livepics = this.tuluTk.cover_pic;
                                    if (this.tuluTk.bid_price == 0) { //出价跳转类型
                                        this.chujiadis = true;
                                    } else {
                                        this.chujiadis = false;
                                    }
                                } else {
                                    this.tuluTkShow = false;
                                    this.baseList.livepics = this.baseList.livepic;
                                }
                                if (this.baseList.live_type == 2 && this.baseList.auction_status == 2 && this.tuluTkShow == true) {
                                    this.focusShow = true;
                                } else {
                                    this.focusShow = false;
                                }
                            } else {
                                this.tuluTkShow = false;
                            }
                            this.$refs.focus.focusFun(this.focusShow);
                        } else if (extra.auction_status == 5) { //重拍
                            this.getLiveReloadList(extra.art_id, extra.next_art_id, false); //重拍接口
                        } else if (extra.auction_status == 6) { //跳过
                            that.getLiveReloadList(extra.art_id, extra.next_art_id, true);
                        }
                        if (extra.auction_status == 1 || extra.auction_status == 4) { //成交、即将落槌
                            if (extra.hammer_price_show || extra.auction_status == 4) {
                                this.luoShow = true;
                                this.luojia = extra.hammer_price_show
                                this.luoFun(extra.auction_status, 2)
                            }

                        } else {
                            this.luoShow = false;
                            this.luojia = ''
                        }
                        if ((extra.auction_status == 1 || extra.auction_status == 2) && (extra.statistics != null && extra.statistics != undefined && extra.statistics != '')) { //成交、流拍
                            this.statisticalData = JSON.parse(extra.statistics); //拍品--统计
                            this.zongshu = 0;
                            this.statisticalData.forEach(item => {
                                this.zongshu = this.zongshu + item.number
                            });
                        }
                        if (extra.auction_status != 4) { //不为即将落槌
                            this.chujiaData = [] //出价数据为空
                        }
                    } else if (data.mt == '14' && data.chatType == 5) { //出价
                        if (extra.bid_status == 3 && extra.auction_status != 6) { //出价类型：2忽略不处理； 3正常处理 auction_status为6为补录 忽略
                            //当前拍品的“当前价”、“下口价”及“币种--价格前缀”
                            this.tuluTk.extra_info.forEach(item => {
                                if (item.type == 'current_price') { //当前价
                                    item.text = extra.price_show
                                } else if (item.type == 'next_price') { //下口价
                                    item.text = extra.next_price_show
                                }
                            });
                            this.tuluTk.bid_price = extra.next_price
                            //this.tuluTk.currency_type=extra.currency_type;//币种--价格前缀
                            this.chujiaData.unshift( //弹幕--出价--添加数据
                                {
                                    id: extra.art_id,
                                    name: extra.bid_username_hide,
                                    money: extra.price_show,
                                    currency_type: extra.currency_type
                                }
                            )
                            if (this.liveData.isLogin == 1 && extra.bid_uid == this.yhxx.imRoles[0].uid) { //出价用户是当前用户
                                this.$toast('出价成功~');
                            }
                            _this.chujiaClass = 'barrage-list barrage-list_1'
                            setTimeout(function () {
                                _this.chujiaClass = 'barrage-list barrage-list_1 barrage-list_1_1'
                            }, 0.1 * 1000);
                        }
                    } else if (data.mt == '15' && data.chatType == 5) { //溢价榜
                        this.tuluListOld.forEach(item => {
                            if (extra.art_id == item.art_id) {
                                item.extra_info.push({
                                    type: "premium",
                                    label: "溢价率",
                                    text: extra.premium_show,
                                    small_text: "+"
                                })
                                item.premium = extra.premium;
                                // this.premiumData.unshift(item); //拍品--溢价榜--增加拍品
                            }
                        });
                        this.getYiJia(extra.art_id); //新纪录榜接口
                        //按照premium倒序排序
                        // var newArr = this.premiumData.sort(
                        //     function (a, b) {
                        //         return (b.premium - a.premium);
                        //     }
                        // );
                        // this.premiumData = newArr; //拍品--溢价榜--排序
                    } else if (data.mt == '16' && data.chatType == 5) { //新纪录榜
                        this.getXinjilu(extra.art_id); //新纪录榜接口
                    }
                    if (extra.auction_detail && extra.auction_detail.length > 0) {
                        // this.tuluTk.extra_info = extra.auction_detail[0].extra_info
                        this.tuluTk.title = extra.auction_detail[0].title
                    }
                }
            });
        },
        ...mapActions({
            fetchToLive: "live/fetchToLive"
        }),
        shipin() {
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 1); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                sessionStorage.setItem("zbUrl", this.baseList.videohsl_url); //直播地址

                this.containerShow = true;
                this.playerPlay() //视频--播放
            }
            this.anniu = false;
        },
        shipin2() {
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 2); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                sessionStorage.setItem("zbUrl", this.tongshengUrl); //直播地址
                console.log(this.tongshengUrl)

                this.playerPlay2() //视频--播放
            }
        },
        shipin3() {
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 3); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                sessionStorage.setItem("zbUrl", this.tongshengUrl); //直播地址
                this.playerPlay3() //视频--播放
            }
        },
        shipin4() {
            let that = this;
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 4); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                if((/(HarmonyOSTulu)/g).test(window.navigator.userAgent)&&!this.baseList.historyurl.includes('https')){
                    this.baseList.historyurl = this.baseList.historyurl.replace("http", "https");
                }
                
                
                sessionStorage.setItem("zbUrl", this.baseList.historyurl); //直播地址
                this.playerPlay4() //视频--播放
            }
        },
        shipin5() {
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 5); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                sessionStorage.setItem("zbUrl", this.tongshengUrl); //直播地址
                this.playerPlay5() //视频--播放
            }
        },
        shipin6() {
            sessionStorage.setItem("zbType", 0); //直播类型--1：直播中--视频直播--直播流；2：直播中--同声传译--直播流；3：直播中--同声传译--视频；4：直播结束--视频直播--回放视频；5：直播结束--同声传译--回放视频；6：直播结束--同声传译--直播流；
            sessionStorage.setItem("zbUrl", ''); //直播地址
            if (this.baseList.auction_live_type == 2) {
                sessionStorage.setItem("zbType", 6); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                sessionStorage.setItem("zbUrl", this.tongshengUrl); //直播地址
                this.playerPlay6() //视频--播放
            }
        },
        filteData() {
            var data = this.$store.state["live"]["data"];
            if (data != '' && data != null && data != undefined) {
                //赋值meta
                document.title = data.meta ? data.meta.title : '';
                let head = document.getElementsByTagName('head');
                if (!document.querySelector('meta[name=description]')) {
                    let meta = document.createElement('meta');
                    meta.name = 'description';
                    meta.content = data.meta ? data.meta.description : '';
                    head[0].appendChild(meta)
                } else {
                    document.querySelector('meta[name=description]').setAttribute('content', data.meta ? data.meta.description : '')
                }
                window.AFedWxShareData = {
                    title: data.meta ? data.meta.shareTitle : '',
                    imgUrl: data.meta.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
                    desc: data.meta.description || '',
                    link: window.location.href
                }
                getWXConfig(window.AFedWxShareData)
            }
        },
        getLiveStatus(type, shu) { //直播详情状态
            if (shu == 0) {
                let obj = {
                    liveid: Number(this.$route.query.id), //直播id
                    type: 0, //类型
                }
                liveStatus(obj).then((res) => {
                    var datas = res.data
                    this.baseList.pauseurl = datas.pauseurl
                    if (type == 1) {
                        this.containerZtShu = 1
                    } else if (type == 2) {
                        this.containerZtShu2 = 1
                    } else if (type == 3) {
                        this.containerZtShu3 = 1
                    }
                })
            }
        },
        getAuctionBids(page) { //竞拍拍品--出价记录
            let obj = {
                art_id: Number(this.baseList.current_art_id), //拍品id
                page: Number(page), //分页
            }
            auctionBids(obj).then((res) => {
                var datas = res.data.list
                datas.forEach((item, index) => { //弹幕--出价--添加数据
                    if (index < 3) {
                        item.name = item.bid_user
                        item.money = item.price_show
                        this.chujiaData.push(item)
                    }
                });
            })
        },
        companyFun(item) { //拍卖公司
            if (item.organ_code != '') {
                if (this.watermarkShow == true) { //有水印
                    window.location.href = 'https://m-auction.artron.net/organ/' + item.organ_code + '?from=2&fromlink=' + encodeURIComponent(window.location.href);
                } else { //无水印
                    window.location.href = 'https://m-auction.artron.net/organ/' + item.organ_code + '?fromlink=' + encodeURIComponent(window.location.href);
                }
            }
        },
        getCreat2() { //根据登录用户获取授权
            creat2().then((res) => {

                this.yhxx = res.data;
                sessionStorage.setItem("token", res.data.token);
                this.getLiveDetail();
            })
        },
        getLiveAuctionList(company_data, status, list_type, last_id, next_last_id, current_art_id) { //直播间拍品列表
            let obj = {
                liveid: Number(this.$route.query.id), //直播id
                order_by: 2, //排序  默认2  0-主键升 1-主键降 2-图录升 3-图录降 4-成交价升 5-成交价降 6-估价升 7-估价降
                special_id: company_data.special_id, //专场id
                special_code: company_data.special_code, //专场code
                last_id: last_id.indexOf("*") != -1 ? last_id.replace("*", "") : last_id,
                status: Number(status), //拍品状态 1 拍卖中 2 结拍
                list_type: Number(list_type), //拍品查询类型 1：包含last_id ,0 不包含
                next_last_id: next_last_id,
                current_art_id: current_art_id
            }
            liveAuctionList(obj).then((res) => {
                var datas = res.data.list;
                // eslint-disable-next-line no-debugger
                this.havePrice = res.data.have_price;
                this.tuluListMore = res.data.morepage;
                if (Number(status) == 1) { //拍卖中
                    if (res.data.morepage == 1) {
                        this.$refs.moreList.onLoadzt(false, false); //加载更多状态
                    } else {
                        this.$refs.moreList.onLoadzt(false, true); //加载更多状态
                    }
                    datas.forEach(item => { //拍卖中拍品
                        this.tuluList.push(item)
                    });

                    //拍品显示
                    if (this.tuluList.length > 0) {
                        this.tulu = res.data

                        this.tuluTk = this.tuluList[0];
                        if (this.tuluTk.status == 2) {
                            this.tuluTkShow = true
                        }
                        this.tuluTk.deposit_amount = this.tulu.deposit_amount;
                        //this.tuluTk.currency_type='RMB';
                        this.baseList.livepics = this.tuluTk.cover_pic;
                        if (this.tuluTk.bid_price == 0) { //出价跳转类型
                            this.chujiadis = true;
                        } else {
                            this.chujiadis = false;
                        }
                    } else {
                        this.baseList.livepics = this.baseList.livepic;
                        this.tuluTkShow = false;
                    }
                    if (this.baseList.live_type == 2 && this.baseList.auction_status == 2 && this.tuluTkShow == true) {
                        this.focusShow = true;
                    } else {
                        this.focusShow = false;
                    }
                    this.$refs.focus.focusFun(this.focusShow);
                } else if (Number(status) == 2) { //已结拍
                    if (res.data.morepage == 1) {
                        this.$refs.moreList.onLoadzt2(false, false); //加载更多状态
                    } else {
                        this.$refs.moreList.onLoadzt2(false, true); //加载更多状态
                    }
                    datas.forEach(item => { //已结拍拍品
                        this.tuluListOld.push(item)
                    });
                    if (this.tuluListOld.length > 0) {

                        if (res.data.special_name) {
                            this.tulu = res.data
                        }

                    }
                }

                if (this.$route.query.moreListShow == 'true') { //拍品详情跳转显示
                    this.moreOver()
                }
            })
        },
        getYiJia() { //新纪录榜接口
            let obj = {
                liveid: Number(this.$route.query.id), //直播id
                special_id: Number(this.$route.query.special_id), //专场id
                type: 2 //状态 1 新纪录 2 溢价
            }
            liveAuctionStatistics(obj).then((res) => {

                this.premiumData = res.data.list //新纪录榜
                if (this.premiumData.length > 20) {
                    this.premiumData.slice(0, 20)
                }
                this.$forceUpdate(); //数据更改之后强制渲染页面
            })

        },
        getXinjilu() { //新纪录榜接口
            let obj = {
                liveid: Number(this.$route.query.id), //直播id
                special_id: Number(this.$route.query.special_id), //专场id
                type: 1, //状态 1 新纪录 2 溢价
            }
            liveAuctionStatistics(obj).then((res) => {
                // this.statisticalData = res.data.statistics
                // this.zongshu = 0;
                // this.statisticalData.forEach(item => {
                //     this.zongshu = this.zongshu + item.number
                // });
                // if (type == 1) {
                //     this.newRecordData = res.data.list //新纪录榜
                // } else if (type == 2) {
                //     this.premiumData = res.data.list //溢价榜
                // }

                // if (this.$route.query.announcementShow == 'true') { //拍品详情跳转显示
                //     this.announcementOver()
                // }
                this.newRecordData = res.data.list //新纪录榜
                if (this.newRecordData.length > 20) {
                    this.newRecordData.slice(0, 20)
                }
                this.$forceUpdate(); //数据更改之后强制渲染页面
            })
            // let obj = {
            //     art_id: Number(art_id), //新纪录榜拍的id
            //     special_id: Number(this.$route.query.special_id), //专场id
            // }
            // liveReloadList(obj).then((res) => {
            //     var data = res.data.list[0]
            //     this.newRecordData.unshift(data); //拍品--新纪录榜--增加拍品
            // })
        },
        getLiveReloadList(art_id, next_art_id, jumpFlag) { //直播间重拍数据
            let that = this;
            let obj = {
                art_id: Number(art_id), //当前重拍的id
                next_art_id: Number(next_art_id), //下一件拍品id
                special_id: Number(this.$route.query.special_id), //专场id
            }
            liveReloadList(obj).then((res) => {
                var data = res.data.list
                data.forEach(item => {
                    if (item.status == 2) { //重拍拍品
                        this.congpaiData[0] = item;
                    } else if (item.status == 1) { //下件拍品
                        this.congpaiData[1] = item;
                    }
                });
                //this.congpaiData=res.data.list
                this.tuluList.splice(0, 1); //拍卖中--删除第一件拍品
                if (obj.next_art_id > 0) {
                    this.tuluList.unshift(this.congpaiData[1]); //拍卖中--增加拍品--下件拍品
                }
                this.tuluList.unshift(this.congpaiData[0]); //拍卖中--增加拍品--重拍拍品
                this.tuluListOld.forEach((item, index) => {
                    if (this.congpaiData[0].art_id == item.art_id) {
                        this.tuluListOld.splice(index, 1); //已结拍--删除重拍拍品
                    }
                });
                this.tuluTk = this.congpaiData[0]; //弹框--重拍拍品
                this.premiumData.forEach((item, index) => {
                    if (this.congpaiData[0].art_id == item.art_id) {
                        this.premiumData.splice(index, 1); //溢价榜--删除重拍拍品
                    }
                });
                //拍品弹框是否显示
                if (this.tuluList.length > 0) {
                    this.tuluTkShow = true;
                    this.baseList.livepics = this.tuluTk.cover_pic;
                } else {
                    this.tuluTkShow = false;
                }
                if (this.baseList.live_type == 2 && this.baseList.auction_status == 2 && this.tuluTkShow == true) {
                    this.focusShow = true;
                } else {
                    this.focusShow = false;
                }
                if (jumpFlag) {
                    // console.log("that.tuluList")
                    // console.log(that.tuluList)
                    that.tuluList.splice(1, 2);
                    // that.tuluList=[];
                    // setTimeout
                    // that.getLiveAuctionList(this.company_data, 1, 1, this.baseList.last_id, this.baseList.next_last_id, this.baseList.current_art_id); 
                    // if (next_art_id == item.art_id) {

                    //     console.log(that.tuluList)
                    //     that.tuluList.splice(index, 1); //删除跳过拍品
                    //     console.log(that.tuluList)
                    // }
                    // });
                }
                this.$refs.focus.focusFun(this.focusShow);

                /* this.tuluTk.extra_info.forEach(item => {
                    if(item.type=='current_price'){//当前价
                        item.text=extra.price_show
                    }else if(item.type=='next_price'){//下口价
                        item.text=extra.next_price_show
                    }
                });
                this.tuluTk.currency_type=extra.currency_type;//币种--价格前缀 */
            })
        },
        getLiveAuctionStatistics(company_data, type) { //直播间拍品统计
            let obj = {
                liveid: Number(this.$route.query.id), //直播id
                special_id: company_data.special_id, //专场id
                type: type, //状态 1 新纪录 2 溢价
            }
            liveAuctionStatistics(obj).then((res) => {
                this.statisticalData = res.data.statistics
                this.zongshu = 0;
                this.statisticalData.forEach(item => {
                    this.zongshu = this.zongshu + item.number
                });
                if (type == 1) {
                    this.newRecordData = res.data.list //新纪录榜
                } else if (type == 2) {
                    this.premiumData = res.data.list //溢价榜
                }

                if (this.$route.query.announcementShow == 'true') { //拍品详情跳转显示
                    this.announcementOver()
                }
            })
        },
        getLiveDetail() { //直播内容详情
            let obj = {
                liveid: this.liveid,
                special_id: Number(this.$route.query.special_id), //专场id
            }
            liveDetail(obj).then((res) => {
                this.code = res.code;
                if (this.code == 0) {
                    var _this = this;
                    this.$refs.codeHtml.codeHtmlFun(false)
                    var data = res.data;
                    this.liveData = data; //数据
                    this.artData = data.artData; //艺术号信息
                    this.artId = data.artId; //艺术号id
                    this.attribute = data.attribute; //属性 
                    this.baseList = data.baseList; //基础

                    // if(this.liveid == '4711'){
                    //     this.baseList.auction_status=2
                    //     this.liveData.direction=1
                    //     this.baseList.auction_live_type=2
                    // }
                    if ((this.baseList.live_type == 1 || this.baseList.live_type == 3) && this.baseList.auction_live_type == 2) {
                        if (this.baseList.livestatus == 0) {
                            this.baseList.auction_status = 1
                        }
                        if (this.baseList.livestatus == 1) {
                            this.baseList.auction_status = 2
                        }
                        if (this.baseList.livestatus == 2) {
                            this.baseList.auction_status = 3
                        }
                    }
                    let str = ''
                    if (this.baseList.auction_status == 3) {
                        str = '直播回顾 | '
                    } else if (this.baseList.auction_status == 2) {
                        str = '直播中 | '
                    } else {
                        str = '直播预告 | '
                    }
                    let liveData = this.$store.state["live"]["data"];

                    if (liveData != '' && liveData != null && liveData != undefined) {
                        // window.AFedWxShareData = {
                        //     title: liveData.meta ? str + liveData.meta.shareTitle : '',
                        //     imgUrl: liveData.meta.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
                        //     desc: liveData.meta.description || '',
                        //     link: window.location.href
                        // }
                        // getWXConfig(window.AFedWxShareData)
                    }
                    if (this.baseList.live_type == 1) {
                        this.goodsList = data.goods;
                    }
                    // this.baseList.ispause = 1;
                    this.chatRoomId = data.chatRoomId; //聊天室id
                    this.comment = data.comment; //评论列表
                    this.company_data = data.company_data; //拍卖机构信息
                    this.direction = data.direction; //展示形式
                    this.function_menu = data.function_menu; //更多菜单
                    this.goods = data.goods; //拍品列表
                    this.isChatRoom = data.isChatRoom; //
                    this.isLogin = data.isLogin; //是否登录
                    this.iscollected = data.iscollected; //选择
                    this.seed = data.seed; //
                    this.shareinfo = data.shareinfo; //分享信息
                    this.zxpInfo= data.zxpInfo; //分享信息
                    this.viewStatus = data.viewStatus; //状态
                    this.shuliang = this.baseList.limit; //拍品列表每页的条目数
                    this.pinglunData = this.liveData.comment.commentList; //弹幕--评论
                    //是否付费视频 1:视频付费不可看；0 可以看
                    if (this.baseList.sale_type > 0) {
                        this.$refs.nonmember.nonmemberFun(true);
                        this.loading = false;
                        return false;
                    } else {
                        this.$refs.nonmember.nonmemberFun(false);
                    }
                    if (this.baseList.notice != '' && this.baseList.notice != null && this.baseList.notice != undefined) {
                        this.pinglunData.push( //弹幕--评价--添加数据
                            {
                                uid: '',
                                username: this.baseList.notice,
                                content: ''
                            }
                        )
                    }
                    if (this.pinglunData.length > 0 && this.liveData.baseList.comment_on == 1) {
                        this.ifShowComment = true
                        this.$refs.barrage && this.$refs.barrage.jiapl(); //评论动画
                    }
                    //同声传译类型
                    this.function_menu.forEach(item => {
                        if (item.menu_type == 1) {
                            item.sub_list.forEach(items => {
                                if (items.menu_type == 13) {
                                    this.tongshengUrl = items.parameter //同声传译url
                                    if (this.tongshengUrl.indexOf('mp4') == -1) { //直播流
                                        this.tongshengType = 1
                                    } else { //视频地址
                                        this.tongshengType = 2
                                    }
                                }
                            })
                        }
                    });
                    this.plShow = this.comment.commentMorePage == 0 ? true : false;
                    this.lid = this.comment.lastId;

                    if (this.baseList.auction_status == 3) {
                        setTimeout(function () {
                            _this.xianshiHt = false
                        }, 5 * 1000);
                        this.getLiveAuctionList(this.company_data, 2, 1, '', this.baseList.next_last_id, this.baseList.current_art_id); //直播间拍品列表--已结拍

                    } else {
                        this.getLiveAuctionList(this.company_data, 1, 1, this.baseList.last_id, this.baseList.next_last_id, this.baseList.current_art_id); //直播间拍品列表--拍卖中
                        this.getLiveAuctionList(this.company_data, 2, 1, '', this.baseList.next_last_id, this.baseList.current_art_id); //直播间拍品列表--已结拍

                    }
                    if (this.baseList.live_type == 2) {
                        this.getLiveAuctionStatistics(this.company_data, 1); //直播间拍品统计--新纪录
                        this.getLiveAuctionStatistics(this.company_data, 2); //直播间拍品统计--溢价
                    }
                    /* 判断协议弹框是否显示--开始 */
                    /* var uid=sessionStorage.getItem('uid');
                    var liveids=sessionStorage.getItem('liveids');
                    if(Number(liveids)!=Number(this.liveid)){
                        sessionStorage.setItem("agreementChecked",'');
                    }
                    var agreementChecked=sessionStorage.getItem('agreementChecked');
                    if(Number(this.baseList.auction_status)!=3){//直播状态不能为已结束
                        if(this.yhxx.imRoles.length>0 && uid==this.yhxx.imRoles[0].uid && Number(liveids)==Number(this.liveid) && agreementChecked=='true'){
                            this.agreementOver(false);
                            this.loading=false;
                        }else if(this.yhxx.imRoles.length==0 && Number(liveids)==Number(this.liveid) && agreementChecked=='true'){
                            this.agreementOver(false);
                            this.loading=false;
                        }else{
                            this.getBidAgreement();//参拍协议
                        }
                    }else{
                        this.loading=false;
                    }
                    //协议是否显示--赋值
                    sessionStorage.setItem("liveids",this.liveid);//直播id
                    sessionStorage.setItem("uid", this.yhxx.imRoles.length>0 ? this.yhxx.imRoles[0].uid : this.yhxx.defaultRoles.uid);//登录用户id */

                    if (Number(this.baseList.auction_status) == 2) { //直播状态为直播中
                        if (this.yhxx.imRoles != '' && this.yhxx.imRoles != null && this.yhxx.imRoles != undefined) {
                            if (this.yhxx.imRoles.length > 0) { //用户登录
                                var liveid = this.$route.query.id //直播id
                                var special_id = this.$route.query.special_id //专场id
                                var uid = this.yhxx.imRoles[0].uid //用户id
                                var agreementChecked = sessionStorage.getItem('agreementChecked');
                                var agreementCheckedArr = [];
                                if (agreementChecked != '' && agreementChecked != null && agreementChecked != undefined) {
                                    agreementCheckedArr = agreementChecked.split("、");
                                }
                                let i = 0;
                                agreementCheckedArr.forEach(item => {
                                    if (item == liveid + '-' + special_id + '-' + uid) {
                                        this.agreementOver(false);
                                        this.loading = false;
                                    } else {
                                        i++
                                    }
                                });
                                if (i == agreementCheckedArr.length) {
                                    this.getBidAgreement(); //参拍协议
                                }
                            } else if (this.yhxx.imRoles.length == 0) { //用户未登录
                                /* let i=0;
                                agreementCheckedArr.forEach(item => {
                                    if(item==liveid+'-'+special_id+'-'+uid){
                                        this.agreementOver(false);
                                        this.loading=false;
                                    }else{
                                        i++
                                    }
                                });
                                if(i==agreementCheckedArr.length){
                                    this.getBidAgreement();//参拍协议
                                } */
                                this.agreementOver(false);
                                this.loading = false;
                            }
                        } else {
                            this.loading = false;
                        }
                    } else {
                        this.loading = false;
                    }
                    /* 判断协议弹框是否显示--结束 */
                    if ((this.baseList.auction_status == 2 || this.baseList.auction_status == 3) && this.baseList.auction_live_type == 2 && this.liveData.direction == 2) { //竖屏全屏
                        this.shipinHeight = document.body.offsetHeight
                        sessionStorage.setItem("pingType", 2) //小窗视频类型；1：横屏；2：竖屏
                    } else { //竖屏小屏
                        this.shipinHeight = document.body.offsetWidth * 9 / 16
                        sessionStorage.setItem("pingType", 1) //小窗视频类型；1：横屏；2：竖屏
                    }
                    this.tuwenHeight = document.body.offsetWidth
                    this.tuTop = (document.body.offsetHeight - document.body.offsetWidth) / 2 //图文的top值
                    this.xianshiH = document.body.offsetHeight //显示的高度
                    //评论的高度
                    //var ua = navigator.userAgent.toLowerCase();  
                    //if(ua.match(/MicroMessenger/i)=="micromessenger") {//微信浏览器  
                    if (this.baseList.auction_status == 2) {
                        this.plHeight = document.body.offsetHeight - (document.body.offsetWidth * 9 / 16) - (9.2 * document.body.offsetWidth / 375 * 20) //评论的高度
                        this.jinerBottom = document.body.offsetHeight - (document.body.offsetWidth * 9 / 16) - (3.5 * document.body.offsetWidth / 375 * 20) //金额的底边距
                        this.jinBottom = document.body.offsetHeight - (document.body.offsetWidth * 9 / 16) - (5.8 * document.body.offsetWidth / 375 * 20) //进入的底边距
                    } else {
                        this.plHeight = document.body.offsetHeight - (document.body.offsetWidth * 9 / 16) - (12.5 * document.body.offsetWidth / 375 * 20) //评论的高度
                        this.jinerBottom = 0 //金额的底边距
                        this.jinBottom = document.body.offsetHeight - (document.body.offsetWidth * 9 / 16) - (5.8 * document.body.offsetWidth / 375 * 20) //进入的底边距
                    }

                    this.getJinRu() //进入直播间
                    sessionStorage.setItem("zbYun", 0); //直播是否运行--0：没运行；1--已运行
                    if (this.baseList.auction_live_type == 2) { //视频
                        if (this.baseList.auction_status == 2) { //直播中
                            this.qhmsType = 11;
                            if (this.anniu == false && this.baseList.ispause == 0) {
                                this.shipin()
                            }
                            if (this.baseList.ispause == 0) {
                                sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
                            }
                        } else if (this.baseList.auction_status == 3) { //直播已结束
                            if (this.baseList.ispersistent == 1) {
                                sessionStorage.setItem("zbType", 4); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
                                if((/(HarmonyOSTulu)/g).test(window.navigator.userAgent)&&!this.baseList.historyurl.includes('https')){
                                    this.baseList.historyurl = this.baseList.historyurl.replace("http", "https");
                                }
                                sessionStorage.setItem("zbUrl", this.baseList.historyurl); //直播地址
                            }
                        }
                    }
                    if (this.baseList.auction_live_type == 1) { //图文
                        this.qhmsType = 12;
                    }

                    if (this.baseList.ispause == 1) {
                        _this.containerShow = false
                        _this.containerZt = true
                        _this.noneText = '主播走开了，请稍等片刻'
                        _this.getLiveStatus(1, _this.containerZtShu)
                    } else if (this.baseList.ispause == 0) {
                        _this.containerShow = true
                        _this.containerZt = false
                        _this.containerZtShu = 0
                        _this.noneText = ''
                    }
                    this.changlian(); //长链推送信息
                } else {
                    this.$refs.codeHtml.codeHtmlFun(true, res.message)
                    this.loading = false;
                }
            })
        },
        getBidAgreement() { //参拍协议
            let obj = {
                liveid: this.liveid,
            }
            bidAgreement(obj).then((res) => {
                this.xieyiData = res.data
                this.agreementOver(true); //协议弹框显示
                this.loading = false;
            })
        },
        getBidAgreementTyi() { //参拍协议--同意
            var liveid = this.$route.query.id //直播id
            var special_id = this.$route.query.special_id //专场id
            var uid = ''
            if (this.yhxx.imRoles != '' && this.yhxx.imRoles != null && this.yhxx.imRoles != undefined) {
                uid = this.yhxx.imRoles[0].uid //用户id
            } else {
                uid = this.yhxx.defaultRoles.uid //用户id
            }
            var agreementChecked = sessionStorage.getItem('agreementChecked');
            //协议是否显示--赋值
            if (agreementChecked != '' && agreementChecked != null && agreementChecked != undefined) {
                if (agreementChecked.indexOf(liveid + '-' + special_id + '-' + uid) == -1) {
                    sessionStorage.setItem("agreementChecked", agreementChecked + '、' + liveid + '-' + special_id + '-' + uid); //协议缓存
                }
            } else {
                sessionStorage.setItem("agreementChecked", agreementChecked + '、' + liveid + '-' + special_id + '-' + uid); //协议缓存
            }
        },
        getJinRu() { //长链--进入直播间
            let obj = {
                target: this.liveData.chatRoomId,
                mt: 4,
                chatType: 3,
                content: "进入直播间",
                source: '',
                timestamp: Date.parse(new Date()),
            }
            if (this.yhxx.imRoles != '' && this.yhxx.imRoles != null && this.yhxx.imRoles != undefined) {
                obj.source = JSON.stringify({
                    img: this.yhxx.imRoles[0].avatar,
                    key: this.yhxx.imRoles[0].roleKey,
                    nickName: this.yhxx.imRoles[0].username,
                    user: this.yhxx.imRoles[0].uid + "",
                })
            } else {
                obj.source = JSON.stringify({
                    img: this.yhxx.defaultRoles.avatar,
                    key: this.yhxx.defaultRoles.roleKey + "@tulu",
                    nickName: this.yhxx.defaultRoles.username,
                    user: this.yhxx.defaultRoles.uid,
                })
            }
            changLian(obj).then(() => {
                if (this.baseList.auction_status == 2) {
                    this.getAuctionBids(1); //竞拍拍品--出价记录
                }
            })
        },
        //更多--跳转、显示
        select(item) {
            if (item.menu_type == 3) { //拍卖统计
                this.announcementOver();
            }
        },
        //更多--展开
        select2() {
            this.show = !this.show;
        },
        //更多--收起
        pack() {
            this.show = !this.show;
        },
        // 调用拨号功能
        callPhone(phoneNumber) {
            window.location.href = 'tel://' + phoneNumber
        },
        zbms(data, row) { //直播模式

            if (row.is_default == 0) {
                data.forEach(item => {
                    if (item.is_default == 1) { //上次选中模式
                        item.is_default = 0
                        var qhmsType = item.menu_type
                        var zbType = sessionStorage.getItem('zbType')
                        /* console.log(qhmsType)
                        console.log(zbType) */

                        if (qhmsType == 11) { //视频直播
                            if (this.baseList.auction_status == 2) { //拍卖中
                                if (zbType == 1 && this.baseList.ispause == 0 && this.anniu == false) {
                                    this.playerStop() //直播流--停止
                                }
                            } else if (this.baseList.auction_status == 3) { //已结拍
                                this.playerStop4(); //视频地址--暂停
                            }
                        } else if (qhmsType == 12) { //图文直播

                        } else if (qhmsType == 13) { //同声传译
                            if (this.baseList.auction_status == 2) { //拍卖中
                                if (this.tongshengType == 1) {
                                    if (zbType == 2) {
                                        this.playerStop2() //直播流--停止
                                    }
                                } else if (this.tongshengType == 2) {
                                    if (zbType == 3) {
                                        this.playerStop3(); //视频地址--暂停
                                    }
                                }
                            } else if (this.baseList.auction_status == 3) { //已结拍
                                if (this.tongshengType == 1) {
                                    if (zbType == 6) {
                                        this.playerStop6() //直播流--停止
                                    }
                                } else if (this.tongshengType == 2) {
                                    if (zbType == 5) {
                                        this.playerStop5(); //视频地址--暂停
                                    }
                                }
                            }
                        }
                    }
                });
                data.forEach(item => {
                    if (item == row) { //现在选中模式
                        item.is_default = 1
                        this.qhmsType = item.menu_type
                        if (this.qhmsType == 11) { //视频直播
                            if (this.baseList.auction_status == 1) { //待拍卖
                                this.$toast({
                                    message: '直播开始后再来哦～'
                                });
                            } else if (this.baseList.auction_status == 2) { //拍卖中
                                this.baseList.auction_live_type = 2
                                if (this.baseList.ispause == 1) {
                                    this.containerShow = false
                                    this.containerZt = true
                                    this.noneText = '主播走开了，请稍等片刻'
                                    this.getLiveStatus(1, 0)
                                } else if (this.baseList.ispause == 0) {
                                    this.shipin() //直播流--播放
                                }
                            } else if (this.baseList.auction_status == 3) { //已结拍
                                this.baseList.auction_live_type = 2
                                this.shipin4(); //视频地址--播放
                            }
                        } else if (this.qhmsType == 12) { //图文直播
                            if (this.baseList.auction_status == 1) { //待拍卖
                                this.$toast({
                                    message: '直播开始后再来哦～'
                                });
                            } else if (this.baseList.auction_status == 2) { //拍卖中
                                this.baseList.auction_live_type = 1
                            }
                        } else if (this.qhmsType == 13) { //同声传译
                            if (this.baseList.auction_status == 1) { //待拍卖
                                this.$toast({
                                    message: '直播开始后再来哦～'
                                });
                            } else if (this.baseList.auction_status == 2) { //拍卖中
                                this.baseList.auction_live_type = 2
                                if (this.tongshengType == 1) {
                                    this.shipin2() //直播流--播放
                                } else if (this.tongshengType == 2) {
                                    this.shipin3() //视频地址--播放
                                }
                            } else if (this.baseList.auction_status == 3) { //已结拍
                                this.baseList.auction_live_type = 2
                                if (this.tongshengType == 1) {
                                    this.shipin6() //直播流--播放
                                } else if (this.tongshengType == 2) {
                                    this.shipin5() //视频地址--播放
                                }
                            }
                        }
                    }
                });
            }
        },
        //公司介绍
        synopsisOver() {
            this.$refs.synopsis.synopsisFun(true, this.liveData);
        },
        // 点击图录
        moreOver() {
            if (this.baseList.auction_status == 3) {
                this.$refs.moreList.moreListFun(true, this.liveData, 2); //直播间拍品列表--已结拍
            } else {
                this.$refs.moreList.moreListFun(true, this.liveData, 1); //直播间拍品列表--拍卖中
            }
        },
        // 协议是否显示
        agreementOver(show) {
            //this.agreementShow=show;
            if (this.baseList.live_type == 2 && this.baseList.online_auction_type == 1 && (this.baseList.auction_status == 1 || this.baseList.auction_status == 2)) {
                this.$refs.agreement.agreementFun(show);
            }
        },
        // 协议是否显示
        agreementOverFu(show) {
            if (this.baseList.live_type == 2 && this.baseList.online_auction_type == 1 && (this.baseList.auction_status == 1 || this.baseList.auction_status == 2)) {
                this.$refs.agreement.agreementFun(show);
            }
        },
        // 点击商品图标
        shopOver() {
            this.$refs.shop.shopFun(true);
        },
        // 点击拍卖统计
        announcementOver() {
            this.$refs.announcement.announcementFun(true, this.liveData);
        },
        // 点击弹幕
        barrageOver(show) {
            this.barrageShow = show;
            this.$refs.barrage && this.$refs.barrage.barrageFun(show);
        },
        // 点击出价
        offerOver(type, data) {
            this.$refs.offer.offerFun(true, type, this.liveData, data);
        },
        //图录显示
        focusXian(seconds) {
            if (this.baseList.live_type != 1 && this.baseList.live_type != 3) {
                if (this.baseList.auction_status == 2 && this.tuluList.length > 0) {
                    var _this = this;
                    setTimeout(function () {
                        _this.$refs.focus.focusFun(true);
                    }, seconds * 1000);
                }
            }

        },
        //隐藏落槌价
        luoFun(status, seconds) {
            var _this = this;
            this.luoType = status;
            setTimeout(function () {
                _this.luoShow = false;
                _this.luojia = ''
            }, seconds * 1000);
        },
        //关闭
        guanbi() {
            this.$router.push({
                path: '/liveList'
            });
        },
        //未登录
        noLogin() {
            this.$toast('暂未登录，请先登录~');
            setTimeout(function () {
                //window.location.href = "https://passport.artron.net/login?appId=1&redirect="+window.location.href; 
                window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
            }, 2 * 1000);
        },
        tixing() { //设置直播提醒
            if (this.liveData.isLogin == 0) {
                this.noLogin()
            } else if (this.liveData.isLogin == 1) {
                let obj = {
                    live_id: Number(this.$route.query.id), //直播id
                    special_id: Number(this.$route.query.special_id), //专场id
                }
                liveRemind(obj).then(() => {
                    this.$toast('已设置提醒~');
                    this.baseList.is_remind = 1
                })
            }
        },
        huifang() { //结束弹框--开始直播回放
            this.jieshuShow = false;
            this.playerPlay4();
            sessionStorage.setItem("zbType", 4); //直播类型--1：视频直播--直播流；2：同声传译--直播流；3：同声传译--视频；4：回放视频；
            if((/(HarmonyOSTulu)/g).test(window.navigator.userAgent)&&!this.baseList.historyurl.includes('https')){
                   this.baseList.historyurl = this.baseList.historyurl.replace("http", "https");
            }
            sessionStorage.setItem("zbUrl", this.baseList.historyurl); //直播地址
            sessionStorage.setItem("zbYun", 1); //直播是否运行--0：没运行；1--已运行
        },
        zting() { //结束弹框--暂停直播回放
            this.jieshuShow = true;
            this.$refs.container3_3.pause();
        },

        download() {
            this.$toast('下载功能');
        },
        gotoApp() { //下载App
            var _this = this;
            // _this.$refs.downloadPop.gotoAppDownload(this.appLink + this.$route.query.id + "/" + this.$route.query.special_id, 0)
            // const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            // if (isiOS && (this.baseList.live_type == 1 || this.baseList.live_type == 3)) {

            //     _this.$refs.downloadPop.gotoAppDownload("/2/8")

            // } else {

            // }
            _this.$refs.downloadPop.gotoAppDownload(this.appLink + this.$route.query.id + "/" + this.$route.query.special_id, 0)
        },
        //返回上一层
        back() {
            this.$router.go(-1);
        },
        getLivecommentlist() { //加载更多评论
            let obj = {
                id: Number(this.$route.query.id), //直播id
                special_id: Number(this.$route.query.special_id), //专场id
                type: 12,
                lid: this.lid,
            }
            livecommentlist(obj).then((res) => {
                var data = res.data;
                this.plShow = data.morePage == 0 ? true : false;
                this.lid = data.lastId;
                if (data.list != null && data.list != undefined && data.list.length > 0) {
                    data.list.forEach(item => {
                        this.pinglunData.unshift(item)
                    });
                }
            })
        },
    },
};
</script>

<style>
.shield .vcp-bigplay {
    display: none;
}
</style><style lang="scss" scoped>
@import url("../../assets/css/reset.css");

.verticallyTop {
    top: 5.2rem;
}

/deep/.verticallyClass {
    .vcp-fullscreen {
        video {
            width: 100% !important;
            height: 100% !important;
            padding-top: 0%;
        }
    }

}

/deep/.horizontallyClass {
    .vcp-fullscreen {
        video {
            width: 100% !important;
            height: 100% !important;
            // padding-top: 80%;
        }
    }
}

.load_box,
.jieshu_box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 5;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
}

.load_icon {
    width: 4rem;
    margin-top: 50%;
}

.load_nr {
    width: 100%;
    margin-top: 4%;
    line-height: 1rem;
    font-size: 0.7rem;
    color: #fff;
}

.jieshu_nr {
    width: 100%;
    margin-top: 60%;
    line-height: 1rem;
    font-size: 0.7rem;
    color: #fff;
}

.jieshu_btn {
    padding: 0px 0.8rem;
    margin-top: 0.6rem;
}

.live {
    position: absolute;
    left: 0rem;
    right: 0rem;
    top: 0rem;
    bottom: 0rem;
    width: 100%;
    height: 100%;
    z-index: 6;
    //background:#27282d;
    padding-top: 5.2rem;

    .container {
        width: 100%;
        height: 11rem;
        background: url('') center no-repeat;
        background-size: cover;
    }

    .container_none {
        width: 100%;
        position: relative;
        overflow: hidden;
    }

    .container_none .load_icon {
        z-index: 10;
        position: absolute;
        left: calc(50% - 40px);
        top: calc(30% - 60px);
        margin-top: 0;
        -webkit-filter: blur(0);
        filter: blur(0);

    }

    .container_none_con {
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 0.8rem;
        color: #fff;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 8;
        background: rgba(0, 0, 0, 0.6);
    }

    /deep/ .container_none img {
        filter: blur(5px);
        -webkit-filter: blur(5px);
    }

    .container2 {
        width: 100%;
        height: 11rem;
        background: url('') center no-repeat;
        background-size: 100%;
    }

    .container3 {
        width: 100%;
        height: 11rem;
    }

    .live-toux {
        width: 100%;
        height: 11rem;
        position: fixed;
        left: 0px;
        /* background : url('../../assets/videoImg/ping2.jpg') center no-repeat;
        background-size:100%; */
    }
}

.live0 {
    padding-top: 0rem;
    background: url('') center no-repeat;
    background-size: cover;

    .container_none_con {
        padding-top: 5.2rem;
    }
}

.live2 {
    width: 100%;
    height: 100%;
}

.live2_box {
    width: 100%;
    height: auto;
    position: absolute;
    top: 5.2rem;
    left: 0px;
    z-index: 99;
}

.live2_box2 {
    top: 0rem;
}

.live2_box_con {
    width: 100%;
    position: relative;
    //background:red;
}

.live2_box_con .container4 {
    width: 100%;
}

.live2_box_con img {
    width: 100%;
    height: auto;
    /* max-height:240px; */
}

.tisBox {
    width: 100%;
    height: 11rem;
    background-size: 100%;
    background-color: #27282d;
    filter: blur(10px);
    position: relative;
}

.tisCon {
    width: 100%;
    height: 11rem;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 9;
    text-align: center;
    font-size: 0.8rem;
    color: #fff;
}

.tisCon2 {
    width: 100%;
    height: 11rem;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 9;
    text-align: center;
    z-index: 9;
    .van-button--small{
        height: 1.6rem;
        padding: 0 0.4rem;
        font-size:  0.6rem;
    }
}

.live2_box2 .tisBox,
.live2_box2 .tisCon,
.live2_box2 .tisCon2 {
    top: 5.2rem;
}

.live2_box_zt {
    width: 100%;
    overflow: hidden;
    color: #fff;
    font-size: 0.7rem;
    position: relative;
    z-index: 99;
}

.live2_box2 .live2_box_zt {
    position: absolute;
    top: 16.2rem;
    left: 0px;
}

.live2_box_ztL {
    width: 72%;
    overflow: hidden;
    padding: 0.5rem;
    float: left;
    background: rgba(0, 0, 0, 0.6);
}

.live2_box_ztL span {
    padding: 0.2rem 0.3rem;
    margin-right: 0.2rem;
    font-size: 0.5rem;
    border-radius: 0.2rem;
}

.live2_box_ztL p {
    margin-top: 0.3rem;
}

.live2_box_ztL .s1 {
    background: #18BD6F;
}

.live2_box_ztL .s3 {
    background: #656565;
}

.live2_box_ztR {
    width: 28%;
    padding: 0.5rem;
    float: right;
    background: rgba(0, 0, 0, 0.9);
    line-height: 2.4rem;
    text-align: center;
}

.live2_box_ztR img {
    width: 1rem;
    margin-right: 0.4rem;
}

// 第二层级
/* .secondFloor-live {
    position: absolute;
    left: 0rem;
    right: 0rem;
    top: 0rem;
    bottom: 0rem;
    background-color: rgba(0, 255, 0, 0.1);
    min-height: 100%;
    z-index: 1; */
// background-color: transparent;

// 顶部标题 和观看人次
.live-tit {
    padding: 0.6rem 0.3rem;
    // height: 2rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9rem;
    position: relative;
    z-index: 6;

    .live-zuhe {
        display: flex;
        align-items: center;

        .live-title {
            max-width: 10rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            margin-right: 0.3rem;
        }

        .live-photo {}
    }

    .live-renci {
        font-size: 0.6rem;
        height: 1.5rem;
        color: #ffffff;
        padding: 0.3rem 0.6rem;
        background: rgba(16, 16, 16, 0.6);
        border-radius: 0.75rem;
    }
}

.zxpinfoBox {
    position: absolute;
    bottom: 4rem;
    width: 94%;
    left: 3%;
    border-radius: 0.5rem;
    background: #fff;
    z-index: 6;

    .zxp-img {
        width: 2.5rem;
        height: 2.5rem;
        box-sizing: content-box;
        padding: 0.8rem  0.5rem  0.5rem  0.5rem;
        border-radius: 0.5rem;

    }

    .zxp-text {
        font-size: 0.6rem;
        margin-top: 1.2rem;
        display: -webkit-inline-box;;
        width: calc(100% - 4rem);
        vertical-align: top;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .zxpCrossIcon {
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
    }
}

// 顶部头像
.live-headPhoto {
    display: flex;
    justify-content: space-between;
    padding: 0rem 0.3rem;
    position: relative;

    //z-index: 15;
    // 左边部分
    .headPhoto-1 {
        max-width: 66%;
        padding: 0rem 0.2rem;
        height: 2rem;
        background: rgba(16, 16, 16, 0.6);
        border-radius: 1.25rem;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 12;

        .headP-bq {
            width: 0.5rem;
            height: 0.5rem;
            position: absolute;
            left: 1.2rem;
            bottom: 0.3rem;
            z-index: 99;
        }

        .headP-img {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
        }

        .headP-world {
            margin: 0rem 0.3rem 0rem 0.2rem;
            font-size: 0.7rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
        }
    }

    // 右边部分
    .headPhoto-2 {
        width: auto;
        margin-top: 0.4rem;
        line-height: 1.2rem;
        position: relative;
        z-index: 12;

        .menu-drop {
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            justify-content: space-between;
            padding-right: 6px;

            .menu-dropWorld {
                font-size: 0.6rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                padding: 0.1rem 0.6rem;
                text-align: center;
            }

            .menu-dropImg {
                padding: 0.3rem 0rem;
                height: 1.4rem;
                transition: 0.6s ease all;

                img {
                    height: 100%;
                    float: right;
                }
            }
        }

        .menu-drop-0 {
            padding: 4px 6px 4px 0px;
            background-color: #000000;
            border-radius: 0.25rem 0.25rem 0rem 0rem;
        }

        .menu-drop-02 .menu-dropWorld {
            color: #18BD6F;
        }

        .menu-drop-02 .menu-dropImg {
            transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            /* IE 9 */
            -moz-transform: rotate(90deg);
            /* Firefox */
            -webkit-transform: rotate(90deg);
            /* Safari 和 Chrome */
            -o-transform: rotate(90deg);
            /* Opera */
        }

        .menu-drop:last-child {
            padding-bottom: 6px;
        }

        .menu-up {
            height: 0.9rem;
            line-height: 0.9rem;
            background-color: #000000;
            border-radius: 0rem 0rem 0.25rem 0.25rem;
            text-align: center;
        }
    }
}

// 底部图标
.live-botmIcon {
    position: absolute;
    width: 100%;
    bottom: 1.2rem;
    display: flex;
    align-items: center;
    z-index: 6;

    img {
        margin: 0rem 0.2rem;
    }
}

/* } */
// 搜索框的样式
/deep/ .van-field__left-icon {
    display: none;
}

/deep/ .van-search__content {
    background-color: rgba(0, 0, 0, 0.6);
}

/deep/ .van-search {
    padding: 0rem 0.1rem 0rem 0rem !important;
}

#redmore {
    display: flex;
    align-items: center;
}

/deep/ .van-tabbar {
    background: none;
}

/deep/ .van-tabbar-item--active {
    background: none;
}

/deep/ .tulu .van-info {
    right: -1rem;
    top: 0.4rem;
}

.tulu_tb {
    width: 2.5rem;
}

.pinglun {
    min-width: 6.5rem;
    width: calc(100% - 10rem);
    display: inline-block;
    background: rgba(0, 0, 0, 0.4);
    font-size: 0.6rem;
    color: #fff;
    border-radius: 1rem;
    line-height: 1.5rem;
    padding: 0.1rem 0.8rem;
}

.tulu_bq {
    position: absolute;
    top: 0px;
    left: 2rem;
    z-index: 29999;
    border-color: #FF3B30;
    color: #FF3B30;
    background: #fff;
    font-size: 0.5rem;
    min-width: 0.7rem;
    padding: 0 0.15rem;
}

.jin {
    width: 6rem;
    float: right;
    text-align: center;
    line-height: 1.5rem;
    padding: 0.14rem 0rem;
    font-size: 0.7rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 1rem;
    color: #18BD6F;
    margin-right: 0.2rem;
}

/deep/ .van-field__control {
    color: #fff;
}

/* 隐藏video按钮及控制条 */
/* /deep/ video::-webkit-media-controls-fullscreen-button {//隐藏“全屏”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-play-button {//隐藏“播放暂停”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-timeline {//隐藏“进度条”
    display: none;
}
/deep/ video::-webkit-media-controls-current-time-display{//隐藏“当前时间”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-time-remaining-display {//隐藏“剩余时间”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-mute-button {//隐藏“音量”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-toggle-closed-captions-button {//隐藏“音量”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-volume-slider {//隐藏“音量控制条”按钮
    display: none;
}
/deep/ video::-webkit-media-controls-enclosure{//隐藏所有控件
    display: none;
} */
/deep/ video::-webkit-media-controls {
    display: none !important;
}

.di_img {
    width: 1.3rem;
    height:1.3rem;
}

.jiaBox {
    width: 8rem;
    height: 5rem;
    background: linear-gradient(134deg, #FFEBCD 0%, #EDA94B 100%);
    border-radius: 0.25rem;
    position: absolute;
    top: 24%;
    left: 50%;
    margin-left: -4rem;
    z-index: 999999;
    text-align: center;
    color: #55360B;
}

.jiaBox_name {
    width: 100%;
    line-height: 1rem;
    margin: 1rem 0rem 0.8rem;
    font-weight: bold;
    font-size: 0.8rem;
}

.jiaBox_money {
    width: 100%;
    line-height: 1rem;
    font-size: 0.8rem;
}

.jiaBox_money b {
    font-weight: bold;
}

.jiaBox_money span {
    font-size: 0.4rem;
    margin-right: 0.2rem;
}

.qhmsBox {
    width: 100%;
    height: 0px;
    overflow: hidden;
    transition: 0.6s ease all;
}

.qhmsBox .menu-drop {
    background: rgba(0, 0, 0, 0.6) !important;
}

/deep/ video {
    object-fit: contain !important;
    background: #000;
}

/deep/ .vcp-error-tips {
    margin-top: 0rem !important;
    top: 0rem;
    line-height: 11rem;
    color: unset;
    font-size: 0.7rem;
    background: rgba(0, 0, 0, 0.8);
    height: 100%;
}

/deep/ .live0 {
    .vcp-error-tips {
        padding-top: 5.2rem !important;
    }
}

/deep/ .vcp-poster-pic.default {
    width: 101%;
    height: 101%;
    transform: translate(-50.1%, -50.1%);
}
</style>
